import React, { useState, useEffect, useRef } from 'react';
import { messagesForEvacuation } from '../helpers/messages';
import EvacuationTimesTable from './PublicPodcastScreens/EvacuationTimeTable';
import { logPodcastAction } from '../helpers/AnalyticsTags';
import { getDatabase, ref, onValue } from "firebase/database";
import { generatePodcastScript, geocodeAddress, getPathTimes, getTravelExperienceEnglishSummary } from '../helpers/AI_functions';
import { getStorage, ref as storageRef, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, getDocs, getDoc, doc } from 'firebase/firestore';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { haversineDistance, dijkstra, reconstructPath, formatTime } from '../helpers/generalHelpers';
import { getTravelExperienceToDestinations, buildTravelNarrative, getTravelExperiencesV2, selectTwoDiverseRoutes, buildTravelNarrativeV2 } from '../helpers/route_functions';
import HospitalIcon from "../assets/images/hospital.png";
import SafetyIcon from '../assets/images/safety_icon.png';
import LocationIcon from '../assets/images/user-location.png';
import { getHouseMarkerSize, getTrafficDotProfile } from './InteractiveMaps/mapZoomVisuals';
import FireImage from '../assets/images/fire_img.png'
import ParkingIconGreen from '../assets/images/parking_icon_green.svg';
import WUICastLogo from '../assets/images/wui_cast_logo_orange.png';
import BalloonsOverlay from './FunScreens/BalloonsOverlay';
import HeroFrame from './PublicPodcastScreens/HeroFrame';
import { listAll } from "firebase/storage";
import { getUiText } from '../helpers/localizationHelpers';
import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import { normalizeScenes, getFAQItems, getResourceSegments, getResourceMetaMap, getResourceUiI18n, SCENE_SYMBOLS, routeChecklistItems, 
  extractStreetFromInput,
  streetSimilarity,
  linkStreetName,
  getSmokeOverlayKey,
  createSmokeEmberOverlay } from '../helpers/podcastHelpers';
import { pickNearestGraphNode } from '../helpers/podcastRouteHelpers';
  
import { darkMapStyle, HOSPITAL_LOCATION, LANGUAGES } from '../helpers/mapHelpers';
import SearchBar from '../components/SearchBar';
import "./InteractiveMapUI.css"
import StepCard from './PublicPodcastScreens/StepCard';
import NextStepsModal from './InteractiveMaps/components/NextStepsModal';
import useScreenWakeLock from '../hooks/useScreenWakeLock';
import useDisclaimerGate, { useDisclaimerAudioUrl } from '../hooks/useDisclaimerGate';

// Replace with your actual API key.
const GOOGLE_MAPS_API_KEY = 'AIzaSyASU8wb6swDIo3dNxkyjfraWijCImc3-OU';
const GOOGLE_MAP_LIBRARIES = ["places"];
const FR_FIRE_SMOKE_CENTER = { lat: 37.7198, lng: -122.1220 };
const FR_FIRE_SMOKE_WIND = { x: -1, y: 0.55 };
const FR_FIRE_SMOKE_DENSITY = 3.0;
const FR_FIRE_SMOKE_NORTH_EXPANSION = 1.3;

const firestore = getFirestore();

const containerStyle = {
  width: '100vw',
  height: '100vh'
};

const PODCAST_NODE_IDS_BY_LANG = {
  EN: new Set([
    "2307", "2760", "3263", "77", "817", "819", "1424", "725", "1711", "1692",
    "1862", "1863", "3200", "820", "739", "3242", "2684", "1710", "726", "541",
    "3199", "2854", "3103", "330", "402", "3684", "26", "2318"
  ]),

  MN: new Set([
    "817", "2307", "2760", "819", "3263", "1424",
    "3242", "2854", "1711", "26", "1862", "725"
  ]),

  ES: new Set([
    "817", "2307", "819", "1424"
  ])
};

const center = {lat: 37.721941, lng: -122.127001};
const DEFAULT_LOCATION = { lat: 37.721941, lng: -122.127001 };



// Destination nodes for shortest route search





const RES_URL_KNOW = "https://protect.genasys.com/search";  // Zonehaven Aware
const RES_URL_ALERTS = "https://member.everbridge.net/453003085612570/new";        // Alameda County Alerts (San Leandro)
const RES_URL_GO_BAG = "https://www.ready.gov/kit";
const RES_URL_WATCH  = "https://app.watchduty.org/"; 

const getRoutePlaybackRate = () => {
  if (typeof window === "undefined") return 1;

  const value = Number(new URLSearchParams(window.location.search).get("speed"));
  if (!Number.isFinite(value) || value <= 0) return 1;

  return Math.min(2, Math.max(0.5, value));
};

const InteractiveMap = () => {
  // Existing states
  const initialLang =
   (typeof window !== "undefined" &&
     (new URLSearchParams(window.location.search).get("lang") || "")
   ).toUpperCase() || 'EN';
  const [selectedLanguage, setSelectedLanguage] = useState(initialLang);
  
  const [selectedTab, setSelectedTab] = useState('routes');
  const [podcastStream, setPodcastStream] = useState("");
  const [podcastUploadPoint, setPodcastUploadPoint] = useState(null);
  const [podcastAudioUrl, setPodcastAudioUrl] = useState("");
  const [checkedItems, setCheckedItems] = useState({});
  const [travelExperiences, setTravelExperiences] = useState(false);
  const [isPodcastPlaying, setIsPodcastPlaying] = useState(false);
  const [travelExpNarrativeStream, setTravelExpNarrativeStream] = useState("");
  useScreenWakeLock(isPodcastPlaying);
  const mapRef = useRef(null);
  const podcastAudioRef = useRef(null);
  const safetyCalloutsRef = useRef([]);
  const [routesAudioUrl, setRoutesAudioUrl] = useState("");
  const routesAudioRef = useRef(null);
  const disclaimerAudioUrl = useDisclaimerAudioUrl(selectedLanguage);
  const {
    disclaimerAudioRef,
    disclaimerPhase,
    isDisclaimerPlaying,
    playWithDisclaimer,
    pauseActivePlayback,
    handleDisclaimerEnded,
    resetDisclaimer,
    gateMainPlayback,
  } = useDisclaimerGate(routesAudioRef);
  const routePlaybackRate = getRoutePlaybackRate();
  const routesDataRef = useRef([]);   // ←  NEW
  const activeRouteNodeRef = useRef(null);   // remembers last highlight
  const [destinationNodes, setDestinationNodes] = useState([]);
  const firePolygonsRef = useRef([]);               // to hold the map Polygon instances
  const fireSmokeOverlaysRef = useRef([]);
  const [firePolygons, setFirePolygons] = useState([]); // optional if you ever want to inspect them
  const [isMobile, setIsMobile] = useState(false)
  const prefillDoneRef = useRef(false);
  const [mapReady, setMapReady] = useState(false);
  const wantRoutesAutoplayRef = useRef(false);
  const routesAutoplayInFlightRef = useRef(false);
  const [showNextSteps, setShowNextSteps] = useState(false);
  const [activeStepsTab, setActiveStepsTab] = useState('next');
  const [routeScenes, setRouteScenes] = useState([]);
  const [routeTimings, setRouteTimings] = useState({});
  const hasLoggedPlayRef   = useRef(false);
  const hasLoggedAddressTypingStartedRef = useRef(false);
  const nearestNodeIdRef   = useRef(null);
  const lateQueuesRef = useRef(new Map());

  useEffect(() => {
    if (disclaimerPhase === "playing") setIsPodcastPlaying(true);
    if (disclaimerPhase === "paused" || disclaimerPhase === "awaiting-main-play") {
      setIsPodcastPlaying(false);
    }
  }, [disclaimerPhase]);

  // Map section states
  const [time, setTime] = useState(180);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [simulations, setSimulations] = useState([]);
  const [selectedSimulation, setSelectedSimulation] = useState();
  const [showPolyLines, setShowPolyLines] = useState(false);
  const [showAssumptions, setShowAssumptions] = useState(false);
  // Graph data state
  const [graphData, setGraphData] = useState({ links: [], nodes: {}, adjList: {} });
  // New state for car markers (if using Markers)
  const carMarkersRef = useRef([]);
  // We'll continue to use the existing polylineRefs.
  const polylineRefs = useRef([]);
  const circleRef = useRef(null);
  const hasCrossed90Ref = useRef(false);
  const nextStepsShownRef = useRef(false);

  // New state to hold car overlays (if switching to OverlayView, see previous example)
  const [carOverlays, setCarOverlays] = useState([]);
  const [CalloutOverlayClass, setCalloutOverlayClass] = useState(null);

  const [searchText,      setSearchText]      = useState("");   // text in the bar
  const [isSearchingLoc,  setIsSearchingLoc]  = useState(false); // spinner flag

  // Storyboard overlay refs
const linkGeomsRef = useRef({});                // link_id -> WKT geometry
const storyboardLinkPolysRef = useRef(new Map()); // linkId -> google.maps.Polyline
const storyboardNodeMarkersRef = useRef(new Map()); // nodeId -> google.maps.Marker
const storyboardFirePolysRef = useRef([]); // Fire polygon ref
const storyboardSmokeOverlaysRef = useRef(new Map()); // stable smoke key -> OverlayView
const lastStoryboardCameraRef = useRef(null);   // {lat,lng,zoom}
const [activeCallout, setActiveCallout] = useState(null); // { text, bg, textColor } | null
const [balloonsSpec, setBalloonsSpec] = useState(null);
const sceneTimeOverlaysRef = useRef([]); // overlays created from scene.destTimes
const [heroImages, setHeroImages] = useState({});   // { alert: url, blocked_road: url, neighbour_buddy: url }
const [activeHeroUrl, setActiveHeroUrl] = useState(null);
const [heroVisible, setHeroVisible] = useState(false);
const [heroAnim, setHeroAnim] = useState(''); // 'hero-roll-in' | 'hero-roll-out' | ''

const isEnglish = selectedLanguage === 'EN';
const activeChecklistItems = routeChecklistItems ;

const [resourcesAudioUrl, setResourcesAudioUrl] = useState("");
const resourcesAudioRef = useRef(null);
const [activeResourceKey, setActiveResourceKey] = useState(null);   // 'zones' | 'alerts' | null
const [resourceProgress, setResourceProgress] = useState({});       // { key: seconds }

const hospitalMarkerRef = useRef(null);

const [deviceZoom, setDeviceZoom] = useState(
  (typeof window !== "undefined" && window.innerWidth <= 768) ? 14 : 16
);

const uiText = getUiText(selectedLanguage);
const addressFlowText = uiText.addressEntryFlow || {};
const addressFlowErrors = addressFlowText.errors || {};
const addressProgressSteps =
  Array.isArray(addressFlowText.progressSteps) && addressFlowText.progressSteps.length
    ? addressFlowText.progressSteps
    : [
        "Finding your address",
        "Loading simulation data",
        "Preparing your guide",
        "Loading audio"
      ];

const podcastNodeIds = React.useMemo(() => {
  const lang = (selectedLanguage || "EN").toUpperCase();
  return PODCAST_NODE_IDS_BY_LANG[lang] || PODCAST_NODE_IDS_BY_LANG.EN;
}, [selectedLanguage]);

const onTimeQueuesByDestRef = useRef(new Map()); // destId -> Map(linkId -> queuedVehicles)
const onTimeTotalsByDestRef = useRef(new Map()); // destId -> total seconds (leaveOnTime)

const isSeekingRef = useRef(false);
const pauseTimerRef = useRef(null);
const lastAudioSrcRef = useRef('');

const [routeTableRows, setRouteTableRows] = useState([]);
const [routeTableLoading, setRouteTableLoading] = useState(false);
const [routeTableError, setRouteTableError] = useState('');

  const [openInstructionKey, setOpenInstructionKey] = useState(null);
  const [resourceIsPlaying, setResourceIsPlaying] = useState(false);
  const [activeNextStepIndex, setActiveNextStepIndex] = useState(0);
  const [completedNextStepKeys, setCompletedNextStepKeys] = useState([]);
  const [hiddenNextStepKeys, setHiddenNextStepKeys] = useState([]);

const [showAddressEntryFlow, setShowAddressEntryFlow] = useState(true);
const [addressEntryMode, setAddressEntryMode] = useState("form");
const [addressEntryError, setAddressEntryError] = useState("");
const [isPickOnMapMode, setIsPickOnMapMode] = useState(false);
const [addressSuggestions, setAddressSuggestions] = useState([]);
const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);
const [resolvedAddressLabel, setResolvedAddressLabel] = useState("");
const autocompleteServiceRef = useRef(null);
const predictionRequestSeqRef = useRef(0);

const searchLoadingMessages = addressProgressSteps;
const [searchLoadingStep, setSearchLoadingStep] = useState(0);
const [autoplayOutcome, setAutoplayOutcome] = useState("pending");
const autoplayOutcomeRef = useRef("pending");

useEffect(() => {
  let intervalId = null;

  if (isSearchingLoc) {
    setSearchLoadingStep(0);

    intervalId = setInterval(() => {
      setSearchLoadingStep(prev => {
        if (prev >= searchLoadingMessages.length - 2) {
          clearInterval(intervalId);
          return prev; // stay at "Loading podcast"
        }
        return prev + 1;
      });
    }, 3000);
  } else {
    setSearchLoadingStep(0);
  }

  return () => {
    if (intervalId) clearInterval(intervalId);
  };
}, [isSearchingLoc, searchLoadingMessages.length]);

useEffect(() => {
  if (autoplayOutcomeRef.current === "blocked") return;
  if (selectedLocation && !isSearchingLoc && (addressEntryMode === "loading" || addressEntryMode === "ready")) {
    setShowAddressEntryFlow(false);
    setAddressEntryMode("form");
    setAddressEntryError("");
    setIsPickOnMapMode(false);
  }
}, [selectedLocation, isSearchingLoc, addressEntryMode]);

useEffect(() => {
  if (!showAddressEntryFlow || addressEntryMode !== "form" || isSearchingLoc) {
    setAddressSuggestions([]);
    setIsFetchingSuggestions(false);
    return;
  }

  const input = searchText.trim();
  if (input.length < 2) {
    setAddressSuggestions([]);
    setIsFetchingSuggestions(false);
    return;
  }

  if (!window.google?.maps?.places?.AutocompleteService) {
    setAddressSuggestions([]);
    setIsFetchingSuggestions(false);
    return;
  }

  if (!autocompleteServiceRef.current) {
    autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();
  }

  const reqId = ++predictionRequestSeqRef.current;
  const timerId = setTimeout(() => {
    setIsFetchingSuggestions(true);
    autocompleteServiceRef.current.getPlacePredictions(
      {
        input,
        types: ["geocode"],
        componentRestrictions: { country: "us" }
      },
      (predictions, status) => {
        if (reqId !== predictionRequestSeqRef.current) return;

        const ok = status === window.google.maps.places.PlacesServiceStatus.OK && Array.isArray(predictions);
        if (!ok) {
          setAddressSuggestions([]);
          setIsFetchingSuggestions(false);
          return;
        }

        setAddressSuggestions(
          predictions.slice(0, 6).map((prediction) => ({
            id: prediction.place_id || prediction.description,
            value: prediction.description,
            title: prediction.structured_formatting?.main_text || prediction.description,
            subtitle: prediction.structured_formatting?.secondary_text || ""
          }))
        );
        setIsFetchingSuggestions(false);
      }
    );
  }, 220);

  return () => clearTimeout(timerId);
}, [showAddressEntryFlow, addressEntryMode, isSearchingLoc, searchText]);



const clearPauseTimer = () => {
  if (pauseTimerRef.current) {
    clearTimeout(pauseTimerRef.current);
    pauseTimerRef.current = null;
  }
};

const seekWithinResourceSegment = (seg, relSeconds, autoPlay = true) => {
  const a = resourcesAudioRef.current;
  if (!a || !resourcesAudioUrl || !isPlayableSegment(seg)) return;

  const segDur = Math.max(0, seg.end - seg.start);
  const clamped = Math.max(0, Math.min(segDur - 0.05, Number(relSeconds) || 0)); // keep within [0, dur)

  setActiveResourceKey(seg.key);
  setOpenInstructionKey(seg.key); // ensure its panel is open

  a.currentTime = seg.start + clamped;
  if (autoPlay) {
    a.play().catch(() => {});
    setResourceIsPlaying(true);
  }
  setResourceProgress(p => ({ ...p, [seg.key]: clamped }));
};

const logAddressTypingStarted = (value) => {
  if (hasLoggedAddressTypingStartedRef.current || !String(value || "").trim()) return;
  hasLoggedAddressTypingStartedRef.current = true;

  logPodcastAction({
    platform: isMobile ? "mobile" : "web",
    action: "interactive_map_address_typing_started",
    cta: "",
    node: String(nearestNodeIdRef.current || ""),
    param_lang: selectedLanguage,
    chapter: `${String(nearestNodeIdRef.current || "")}_${selectedLanguage}`,
    podcast: selectedSimulation?.name || ""
  });
};

const handleSearchTextInput = (value) => {
  setSearchText(value);
  logAddressTypingStarted(value);
};

const showInstructions = (seg, { alsoOpenLink = false, href } = {}) => {
  setOpenInstructionKey(seg.key);        // open the instructions panel for this item
  playResourceSegment(seg);              // auto-play the audio for this item

  if (alsoOpenLink && href) {
    logPodcastAction({
      platform: isMobile ? 'mobile' : 'web',
      action: 'next_step_clicked_open',
      cta: seg.key,
      node: String(nearestNodeIdRef.current || ''),
      param_lang: selectedLanguage,
      chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
      podcast: selectedSimulation?.name || ''
    });
    try { window.open(href, "_blank", "noopener,noreferrer"); } catch (_) {}
  }
};

useEffect(() => {
  const update = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    setDeviceZoom(mobile ? 15 : 16);
  };
  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);


// Share with neighbors (Web Share API, mailto fallback)
const shareWithNeighbors = () => {
  logPodcastAction({
    platform: isMobile?'mobile': 'web',
    action: 'next_step_clicked',
    cta: 'share_with_neighbors',
    node: String(nearestNodeIdRef.current || ''),
    chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
    param_lang: selectedLanguage,
    podcast: selectedSimulation?.name || ''
  });

  const shareData = {
    title: "Bay-O-Vista Wildfire Plan",
    text: "Check your zone and evacuation routes.",
    url: window.location.href
  };

  if (navigator.share) {
    navigator.share(shareData).catch(() => {});
  } else {
    const subject = encodeURIComponent("Bay-O-Vista wildfire evacuation plan");
    const body = encodeURIComponent(`Check your zone and plan your routes:\n${window.location.href}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }
};

const clearRoutesPodcast = React.useCallback(() => {
  // stop current audio & drop its src
  const a = routesAudioRef.current;
  if (a) { try { a.pause(); } catch {} a.removeAttribute('src'); a.load(); }

  // wipe bundle state so autoplay condition fails
  setRoutesAudioUrl('');
  setRouteScenes([]);
  setRouteTimings({});
  resetDisclaimer();
}, [resetDisclaimer]);

const logRoutePlaybackDiagnostic = (action, cta = "", nodeId = nearestNodeIdRef.current) => {
  logPodcastAction({
    platform: isMobile ? "mobile" : "web",
    action,
    cta: String(cta || ""),
    node: String(nodeId || ""),
    chapter: `${String(nodeId || "")}_${selectedLanguage}`,
    param_lang: selectedLanguage,
    podcast: selectedSimulation?.name || ""
  });
};

const attemptRoutesAutoplay = async (source) => {
  const media = routesAudioRef.current;
  if (!wantRoutesAutoplayRef.current || !media || routesAutoplayInFlightRef.current) return false;

  routesAutoplayInFlightRef.current = true;
  media.playbackRate = routePlaybackRate;
  media.defaultPlaybackRate = routePlaybackRate;
  setSearchLoadingStep(addressProgressSteps.length - 1);
  logRoutePlaybackDiagnostic("interactive_map_autoplay_attempt", source);
  try {
    media.currentTime = 0;
    await playWithDisclaimer({ restart: true });
    wantRoutesAutoplayRef.current = false;
    autoplayOutcomeRef.current = "succeeded";
    setAutoplayOutcome("succeeded");
    logRoutePlaybackDiagnostic("interactive_map_autoplay_succeeded", source);
    return true;
  } catch (error) {
    wantRoutesAutoplayRef.current = false;
    autoplayOutcomeRef.current = "blocked";
    setAutoplayOutcome("blocked");
    setAddressEntryMode("ready");
    setShowAddressEntryFlow(true);
    const reason = error?.name || error?.message || "play_rejected";
    logRoutePlaybackDiagnostic(
      "interactive_map_autoplay_blocked",
      `${source}:${reason}`
    );
    console.warn("Route podcast autoplay was blocked:", error);
    return false;
  } finally {
    routesAutoplayInFlightRef.current = false;
  }
};

useEffect(() => {
  if (mapReady) {
    logPodcastAction({
      platform: isMobile?'mobile': 'web',
      action: 'interactive_map_load',
      cta: '',
      chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
      param_lang: selectedLanguage,
      podcast: selectedSimulation?.name || ''
    });
  }
}, [mapReady, selectedSimulation]);

const loadRouteTableForNode = async (nodeId) => {
  if (!nodeId) return;
  try {
    setRouteTableLoading(true);
    setRouteTableError('');

    const db = getFirestore();
    const snap = await getDoc(doc(db, "podcast_details", String(nodeId)));

    if (!snap.exists()) {
      setRouteTableRows([]);
      return;
    }

    console.log(snap.data())

    const payload = snap.data();
   // Support { routeTables: [...] } (your doc), { routes: [...] }, or a top-level array
  const rows = Array.isArray(payload?.routeTables)? payload.routeTables: Array.isArray(payload?.routes)
   ? payload.routes: Array.isArray(payload)
   ? payload: [];
    setRouteTableRows(Array.isArray(rows) ? rows : []);

    // build linkId -> queuedVehicles (lateEvac) index from route tables
    const idx = new Map();
    (rows || []).forEach(r => {
      const arr = Array.isArray(r.queuedVehiclesLate) ? r.queuedVehiclesLate : [];
      arr.forEach(item => {
        const linkId = item && item.linkId != null ? String(item.linkId) : null;
        if (!linkId) return;
        const count = Number(item.queuedVehicles || 0);
        idx.set(linkId, count);
      });
    });
    lateQueuesRef.current = idx;

    // NEW: indexes for ON-TIME views
   const byDest = new Map();   // destId -> Map(linkId -> queuedVehicles)
   const totals = new Map();   // destId -> total seconds (leaveOnTime)

   (rows || []).forEach(r => {
     const destId = String(r.id ?? '');
     if (!destId) return;

     // Per-link queued vehicles for ON TIME
     const qmap = new Map();
     const arr = Array.isArray(r.queuedVehiclesOnTime) ? r.queuedVehiclesOnTime : [];
     arr.forEach(item => {
       const linkId = item && item.linkId != null ? String(item.linkId) : null;
       if (!linkId) return;
       qmap.set(linkId, Number(item.queuedVehicles || 0));
     });
     byDest.set(destId, qmap);

     // Parse "leaveOnTime" like "17 min" -> seconds
     const s = String(r.leaveOnTime || '').trim();
     let secs = 0;
     const m = s.match(/([\d.]+)\s*min/i);
     if (m) secs = Math.round(parseFloat(m[1]) * 60);
     totals.set(destId, secs);
   });
   onTimeQueuesByDestRef.current = byDest;
   onTimeTotalsByDestRef.current = totals;

  } catch (e) {
    console.error("Failed to load route table:", e);
    setRouteTableError('Could not load evacuation times for this location.');
  } finally {
    setRouteTableLoading(false);
  }
};

async function loadRouteBundleFromFirestore(nodeId, lang) {
  const db = getFirestore();
  const storage = getStorage();
  const langCode = String(lang || "EN").toUpperCase();
  const nid = String(nodeId);

  console.log("podcast_details/",nid,langCode)

  // 1) fetch all three docs in parallel
  const [metaSnap, scenesSnap, timingsSnap] = await Promise.all([
    getDoc(doc(db, "podcast_details", nid, langCode, "podcastMetadata")),
    getDoc(doc(db, "podcast_details", nid, langCode, "ROUTE_SCENES")),
    getDoc(doc(db, "podcast_details", nid, langCode, "routeAudioTimings")),
  ]);


  if (!metaSnap.exists()) throw new Error("podcastMetadata missing");
  if (!scenesSnap.exists()) throw new Error("ROUTE_SCENES missing");
  if (!timingsSnap.exists()) throw new Error("routeAudioTimings missing");

  // 2) resolve audio URL from Storage
  const meta = metaSnap.data() || {};
  const objectPath = meta.objectPath || "";      // e.g. "PodcastMedia/.../Lakeview-Drive_1760901871.mp3"
  const gsUri = meta.gsUri || "";                // e.g. "gs://<bucket>/<path>"
  let audioUrl = "";

  if (objectPath) {
    audioUrl = await getDownloadURL(storageRef(storage, objectPath));
  } else if (gsUri && gsUri.startsWith("gs://")) {
    const [, bucketAndKey] = gsUri.split("gs://");
    const firstSlash = bucketAndKey.indexOf("/");
    const key = firstSlash >= 0 ? bucketAndKey.slice(firstSlash + 1) : "";
    audioUrl = await getDownloadURL(storageRef(storage, key));
  } else {
    throw new Error("No valid objectPath or gsUri on podcastMetadata");
  }

  // 3) extract scene/timing content
  console.log("Scenes doc", scenesSnap.data())
  console.log("Timings doc", timingsSnap.data())

  const rawScenes = Array.isArray(scenesSnap.data()?.content)
  ? scenesSnap.data().content
  : [];
   
  const timings = timingsSnap.data()?.content || {};

  // Decide which default location symbol to use based on presence of key "28"
  const hasEstudilloAlt = Object.keys(timings).some((k) => String(k).includes('I-580 North'));
  console.log(timings)
  SCENE_SYMBOLS.DEFAULT_LOCATION = hasEstudilloAlt
    ? SCENE_SYMBOLS.DEFAULT_LOCATION_2
    : SCENE_SYMBOLS.DEFAULT_LOCATION_1;

  const scenes = normalizeScenes(rawScenes);

  // 4) push into state (so memos depending on these re-compute)
  setRouteScenes(scenes);
  setRouteTimings(timings);
  setRoutesAudioUrl(audioUrl);

  // let the caller decide when/how to play; this guarantees the bundle is loaded
  return { scenes, timings, audioUrl };
}

useEffect(() => {
  const storage = getStorage();
  const paths = {
    alert: "Podcast_images/bovia/alert.jpg",
    blocked_road: "Podcast_images/bovia/blocked_road.jpg",
    neighbour_buddy: "Podcast_images/bovia/neighbour_buddy.jpg",
    go_bag: "Podcast_images/bovia/go_bag.jpg",
    firefighter_congestion: "Podcast_images/bovia/firefighter_congestion.jpg",
    car_abandon_accident: "Podcast_images/bovia/car_abandon_accident.jpg",
    traffic_congestion: "Podcast_images/bovia/traffic_congestion.jpg",
    leave_early: "Podcast_images/bovia/leave_early.jpg",
    know_your_zone: "Podcast_images/bovia/know_your_zone.jpg",
  };

  Promise.all(
    Object.entries(paths).map(async ([key, p]) => {
      try {
        const url = await getDownloadURL(storageRef(storage, p));
        return [key, url];
      } catch (e) {
        console.error("Failed to load hero image:", key, e);
        return [key, null];
      }
    })
  ).then(entries => {
    const map = {};
    entries.forEach(([k, v]) => { if (v) map[k] = v; });
    setHeroImages(map);
  });
}, []);

useEffect(() => {
  if (activeHeroUrl) {
    setHeroVisible(true);
    setHeroAnim('hero-roll-in');
  } else if (heroVisible) {
    // trigger exit animation, then unmount after it finishes
    setHeroAnim('hero-roll-out');
  }
}, [activeHeroUrl]);

useEffect(() => {
  const update = () => {
    const z = window.innerWidth <= 768 ? 15 : 16;
    setDeviceZoom(z);
  };
  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}, []);

const scenesEN = React.useMemo(
  () =>
    (routeScenes || []).map(s => ({
      ...s,
      camera: s.camera ? { ...s.camera, zoom: deviceZoom } : s.camera
    })),
  [routeScenes, deviceZoom]
);

const scenesES = React.useMemo(
  () =>
    (routeScenes || []).map(s => ({
      ...s,
      camera: s.camera ? { ...s.camera, zoom: deviceZoom } : s.camera
    })),
  [routeScenes, deviceZoom]
);

const openResourceAndPlay = (seg, href) => {
  showInstructions(seg, { alsoOpenLink: true, href });
};

// One animation loop per polyline
const linkAnimRef = useRef(new Map()); // polyline -> { raf, cars:[], color:"#186EE3", fft:5 }

const GET_HOUSE_MARKER_ICON = () => {
  const size = getHouseMarkerSize(mapRef.current?.getZoom?.());
  return {
    url: LocationIcon,
    scaledSize: new window.google.maps.Size(size, size),
    anchor: new window.google.maps.Point(size / 2, size / 2)
  };
};

const UPDATE_HOUSE_MARKER_SIZE = () => {
  if (!window.google?.maps) return;
  circleRef.current?.setIcon?.(GET_HOUSE_MARKER_ICON());
};

const STOP_ANIMS = () => {
  linkAnimRef.current.forEach(({ raf, poly }) => {
    if (raf) cancelAnimationFrame(raf);
    // also clear icons so no dots are left
    if (poly) poly.set('icons', []);
  });
  linkAnimRef.current.clear();
};

// show/hide the animated dots on a given polyline
const SET_LINK_ANIM_VISIBLE = (poly, visible) => {
  const st = linkAnimRef.current.get(poly);
  if (!st) return;
  st.visible = !!visible;
  if (!visible) {
    // immediately clear any existing dots
    try { st.poly.set('icons', []); } catch (_) {}
  }
};

// start or restart animation for a single polyline
const START_LINK_ANIM = (poly, color, fftSec, linkId) => {
  const prev = linkAnimRef.current.get(poly);
  if (prev) {
    if (prev.raf) cancelAnimationFrame(prev.raf);
  }

  const state = {
    poly,
    color,                 // moving-dot color, and also used for stroke
    baseColor: color,      // remember original so we can restore after a scene
    baseQueueColor: color,
    linkId: linkId != null ? String(linkId) : null,
    fft: Math.max(0.5, Number(fftSec) || 5),
    cars: [],              // { born:number(ms) }
    lastSpawnAt: performance.now(),
    raf: 0,
    running: true,
    visible: true,
    queue: {
      count: 0,
      baseCount: 0,
      currentCount: 0,     // what we render *right now*
      targetCount: 0,      // what we're animating *toward*
      countTween: { active: false, from: 0, to: 0, start: 0, dur: 800 },
      spacingPct: 4,
      color: '#186EE3',
      multiplier: 1,
      tween: { active: false, from: 1, to: 1, start: 0, dur: 800 } // animate multiplier
    }
  };

  const tick = () => {

    const easeInOut = (u) => (u < 0.5 ? 2 * u * u : -1 + (4 - 2 * u) * u);

    if (!state.running) return;
    const now = performance.now();
    const icons = [];
    const durMs = state.fft * 1000;
    const dotProfile = getTrafficDotProfile(mapRef.current?.getZoom?.());

    if (now - state.lastSpawnAt >= dotProfile.spawnIntervalMs) {
      state.cars.push({ born: now });
      state.lastSpawnAt = now;
      if (state.cars.length > 120) state.cars.splice(0, state.cars.length - 120);
    }

    const gm = window?.google?.maps;
    if (!gm) {
      state.raf = requestAnimationFrame(tick);
      return;
    }

    if (!state.visible) {
      state.poly.set('icons', []);
      state.raf = requestAnimationFrame(tick);
      return;
    }

    // Effective queued count after scene multiplier
    const q = state.queue;

    // tween multiplier (ease in/out)
    let effMult = Math.max(0, q.multiplier);
    if (q.tween && q.tween.active) {
      const elapsed = now - q.tween.start;
      const u = Math.min(1, elapsed / Math.max(1, q.tween.dur));
      const ease = easeInOut(u);
      effMult = q.tween.from + (q.tween.to - q.tween.from) * ease;
      if (u >= 1) {
        q.tween.active = false;
        q.multiplier = q.tween.to;
      }
    }

    let currCount = q.currentCount;
    if (q.countTween && q.countTween.active) {
      const elapsed = now - q.countTween.start;
      const u = Math.min(1, elapsed / Math.max(1, q.countTween.dur));
      const ease = easeInOut(u);
      currCount = q.countTween.from + (q.countTween.to - q.countTween.from) * ease;
      if (u >= 1) {
        q.countTween.active = false;
        currCount = q.countTween.to;
      }
      q.currentCount = currCount; // persist the in-flight value
    }

    // translate tweened multiplier into queued span (dots)
    const effCount = Math.max(0, Math.floor(currCount * effMult));
    const queuedSpanPct = effCount * Math.max(1, q.spacingPct);
    const freeEndPct = Math.max(0, 100 - queuedSpanPct);

    // moving dots only in the free portion
    for (let i = state.cars.length - 1; i >= 0; i--) {
      const age = now - state.cars[i].born;
      if (age >= durMs) { state.cars.splice(i, 1); continue; }
      const travelPct = Math.min(100, (age / durMs) * 100);
      if (travelPct <= freeEndPct) {
        icons.push({
          icon: {
            path: gm.SymbolPath.CIRCLE,
            scale: dotProfile.scale,
            strokeOpacity: 0,
            fillOpacity: 1,
            fillColor: state.color
          },
          offset: `${travelPct}%`
        });
      }
    }

    let effectiveCount = effCount;

    // queued dots from the end backward (clipped to link)
    if (effectiveCount > 0) {
      const qIcon = {
        path: gm.SymbolPath.CIRCLE,
        scale: dotProfile.scale,
        strokeOpacity: 0,
        fillOpacity: 1,
        fillColor: q.color || '#FF3B30'
      };
      for (let i = 0; i < effectiveCount; i++) {
        const offsetFromEnd = i * Math.max(1, q.spacingPct);
        const offset = 100 - offsetFromEnd;
        if (offset < freeEndPct) break;
        icons.push({ icon: qIcon, offset: `${Math.max(freeEndPct, Math.min(100, offset))}%` });
      }
    }

    state.poly.setOptions({ strokeOpacity: 0.35, strokeColor: state.color });
    state.poly.set('icons', icons);
    state.raf = requestAnimationFrame(tick);
  };

  state.raf = requestAnimationFrame(tick);
  linkAnimRef.current.set(poly, state);
};

// update color (e.g., when you flip a link to orange)
const UPDATE_LINK_ANIM_COLOR = (poly, newColor) => {
  const st = linkAnimRef.current.get(poly);
  if (st) st.color = newColor;
};

const SET_LINK_QUEUE = (poly, count, spacingPct = 4, color, opts = {}) => {
  const st = linkAnimRef.current.get(poly);
  if (!st) return;
  const n = Math.max(0, Math.floor(Number(count) || 0));
  const q = st.queue;
  const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
  const { animate = true, duration = 1200, persistBaseline = true } = opts;

  // Store/keep the ON-TIME baseline (first time only, unless explicitly told not to)
  if (persistBaseline) {
    if (q.onTimeCount == null) q.onTimeCount = n;
    if (q.baseCount == null) q.baseCount = n;
    if (color && !st.baseQueueColor) st.baseQueueColor = color;
  }

  // if no prior currentCount, initialize
  if (typeof q.currentCount !== 'number') q.currentCount = 0;

  // set up tween to the new target
  q.targetCount = n;
  if (animate) {
    q.countTween = {
      active: true,
      from: q.currentCount,
      to: n,
      start: now,
      dur: duration
    };
  } else {
    q.countTween = { active: false, from: n, to: n, start: now, dur: 0 };
    q.currentCount = n;
  }
  q.spacingPct = Math.max(1, Number(spacingPct) || 4);
  if (color) {
    q.color = color;
    if (persistBaseline) st.baseQueueColor = st.baseQueueColor || color;
  }
  
};

const APPLY_LATE_QUEUE_COUNTS = () => {
  linkAnimRef.current.forEach(st => {
    const id = st.linkId ? String(st.linkId) : null;
    if (!id) return;
    const q = lateQueuesRef.current.get(id);
    if (q != null) {
      SET_LINK_QUEUE(st.poly, q, 4, "#FF0000", { animate: true, duration: 1400, persistBaseline: false }); // red queue dots while scene is “red”
    }
  });
};

const CLEAR_QUEUE_OVERRIDE = () => {
  linkAnimRef.current.forEach(st => {
    const base = (st.queue.onTimeCount != null ? st.queue.onTimeCount: (st.queue.baseCount != null ? st.queue.baseCount : 0));
    SET_LINK_QUEUE(st.poly, base, st.queue.spacingPct, st.baseQueueColor, { animate: true, duration: 600, persistBaseline: true });
  });
};

const APPLY_TRAFFIC_OVERRIDE = (spec) => {
  const globalColor = spec?.color;
  const targetMultRaw = (typeof spec?.congestionMultiplier === 'number' && !Number.isNaN(spec.congestionMultiplier))
    ? Math.max(0, spec.congestionMultiplier)
    : null;

  const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

  linkAnimRef.current.forEach((st) => {
    if (globalColor) {
      st.color = globalColor;
      st.queue.color = globalColor;
    }

    if (targetMultRaw === null) return;

    const q = st.queue;

    // compute the *current* effective multiplier (don’t snap back to from/to)
    let curr = q.multiplier;
    if (q.tween && q.tween.active) {
      const elapsed = now - q.tween.start;
      const u = Math.min(1, elapsed / Math.max(1, q.tween.dur));
      curr = q.tween.from + (q.tween.to - q.tween.from) * u;
    }

    // if target hasn’t changed, don’t restart the tween
    if (Math.abs(targetMultRaw - curr) < 1e-3) return;

    const to = targetMultRaw;
    const dur = to > curr ? 3000 : 1000; // 3s to build congestion, faster to clear

    q.tween = {
      active: true,
      from: curr,
      to,
      start: now,
      dur
    };
  });
};

const CLEAR_TRAFFIC_OVERRIDE = () => {
  const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

  linkAnimRef.current.forEach((st) => {
    const from = (st.queue.tween && st.queue.tween.active) ? st.queue.tween.to : st.queue.multiplier;

    // decongest quickly back to baseline
    st.queue.tween = {
      active: true,
      from,
      to: 1,
      start: now,
      dur: 500
    };

    st.color = st.baseColor || st.color;
    st.queue.color = st.baseQueueColor || '#186EE3';
  });
};

const activeScenesRef = useRef([]);
useEffect(() => {
  activeScenesRef.current = isEnglish ? scenesEN : scenesES;
}, [isEnglish, scenesEN, scenesES]);

// Load "Podcast media/ResourcesV1.mp4" once
useEffect(() => {
  const storage = getStorage();

  const langCode = String(selectedLanguage || "EN").toUpperCase();
  const path =
    langCode === "MN"
      ? "Podcast media/Next_steps_MN.mp3"
      : langCode === "ES"
      ? "Podcast media/Next_steps_ES.m4a"
      : "Podcast media/Next_steps_EN.mp3";

  // optional: clear old url while loading
  setResourcesAudioUrl("");

  getDownloadURL(storageRef(storage, path))
    .then(setResourcesAudioUrl)
    .catch(err => console.error("Error fetching resources audio:", err));
}, [selectedLanguage]);

useEffect(() => {
  if (prefillDoneRef.current) return;

  const qs = typeof window !== "undefined" ? window.location.search : "";
  if (!qs) return;

  const params = new URLSearchParams(qs.replace(/\?\s*/, "?").replace(/&&/g, "&"));
  const streetParam = params.get("street");


  const graphReady = graphData && Object.keys(graphData.nodes || {}).length > 0;
  const destReady = Array.isArray(destinationNodes) && destinationNodes.length > 0;
  const ready = !!selectedSimulation && destReady && graphReady && mapReady;

  if (streetParam && ready) {
    const streetText = streetParam.trim();
    setSearchText(streetText);

    (async () => {
      try {
        setIsSearchingLoc(true);
        setAddressEntryError("");
        setAddressSuggestions([]);
        setAddressEntryMode("loading");
        setShowAddressEntryFlow(true);
        setIsPickOnMapMode(false);
        autoplayOutcomeRef.current = "pending";
        setAutoplayOutcome("pending");
        wantRoutesAutoplayRef.current = false;

        const { lat, lng } = await geocodeAddress(streetText, "", "");
        const latNum = +lat, lngNum = +lng;

        setSelectedLocation({ lat: latNum, lng: lngNum });

        if (mapRef.current) {
          modifyMapCamera(mapRef.current, { lat: latNum, lng: lngNum }, 15, 1000);
        }

        await drawRoutes(latNum, lngNum, time, selectedSimulation, destinationNodes);
        setResolvedAddressLabel(streetText);
        autoplayOutcomeRef.current = "blocked";
        setAutoplayOutcome("blocked");
        setAddressEntryMode("ready");
        setShowAddressEntryFlow(true);
        setAddressEntryError("");
        setIsPickOnMapMode(false);

        // Only mark done after a successful draw
        prefillDoneRef.current = true;
      } catch (e) {
        console.error("Prefill geocode/draw failed:", e);
        setAddressEntryMode("form");
        setAddressEntryError("We could not find that address. Please check the street parameter and try again.");
        // do not mark done so it can retry when prerequisites change
      } finally {
        setIsSearchingLoc(false);
      }
    })();
  }
}, [selectedSimulation, destinationNodes, time, graphData, mapReady]);


const isPlayableSegment = (s) =>
  Number.isFinite(s?.start) && Number.isFinite(s?.end) && s.end > s.start;

const segmentDuration = (s) =>
  isPlayableSegment(s) ? Math.max(0, s.end - s.start) : 0;

const resourceSegments = React.useMemo(
  () => getResourceSegments(selectedLanguage || 'EN'),
  [selectedLanguage]
);

const resourceMeta = React.useMemo(
  () => getResourceMetaMap(selectedLanguage || 'EN'),
  [selectedLanguage]
);

const resourceUI = React.useMemo(
  () => getResourceUiI18n(selectedLanguage || 'EN'),
  [selectedLanguage]
);

const faqList = React.useMemo(
  () => getFAQItems(isEnglish ? 'EN' : 'EN'),
  [isEnglish]
);

const guidedNextSteps = React.useMemo(() => {
  const resourceItems = (resourceSegments || []).map((seg) => ({
    type: "resource",
    key: seg.key,
    seg,
    meta: resourceMeta[seg.key] || {}
  }));

  return [
    ...resourceItems,
    {
      type: "share",
      key: "share_with_neighbors",
      meta: {
        title: resourceUI.share,
        subtitle: resourceUI.share_desc
      }
    }
  ];
}, [resourceSegments, resourceMeta, resourceUI.share, resourceUI.share_desc]);

const activeNextStep = guidedNextSteps[
  Math.min(activeNextStepIndex, Math.max(guidedNextSteps.length - 1, 0))
];

const completedNextStepSet = React.useMemo(
  () => new Set(completedNextStepKeys),
  [completedNextStepKeys]
);

useEffect(() => {
  if (!guidedNextSteps.length) {
    setActiveNextStepIndex(0);
    return;
  }

  setActiveNextStepIndex((prev) =>
    Math.min(prev, Math.max(guidedNextSteps.length - 1, 0))
  );
}, [guidedNextSteps.length]);

const markNextStepComplete = (key) => {
  setCompletedNextStepKeys((prev) =>
    prev.includes(key) ? prev : [...prev, key]
  );
};

const toggleGuidedStepDetails = (key, defaultHidden = false) => {
  const stateKey = defaultHidden ? `show:${key}` : key;
  setHiddenNextStepKeys((prev) =>
    prev.includes(stateKey)
      ? prev.filter((value) => value !== stateKey)
      : [...prev, stateKey]
  );
};

const goToNextGuidedStep = () => {
  setActiveNextStepIndex((prev) =>
    Math.min(prev + 1, Math.max(guidedNextSteps.length - 1, 0))
  );
  setOpenInstructionKey(null);
  stopResourcePlayback();
};

const skipActiveGuidedStep = () => {
  if (!activeNextStep) return;

  logPodcastAction({
    platform: isMobile ? 'mobile' : 'web',
    action: 'next_step_skipped',
    cta: activeNextStep.key,
    node: String(nearestNodeIdRef.current || ''),
    chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
    param_lang: selectedLanguage,
    podcast: selectedSimulation?.name || ''
  });
  goToNextGuidedStep();
};

const stopResourcePlayback = () => {
  const a = resourcesAudioRef.current;
  if (a) a.pause();
  setResourceIsPlaying(false);

};

const playResourceSegment = (seg, opts = {}) => {
  const { resumeIfSame = false } = opts;
  const a = resourcesAudioRef.current;
  if (!a || !resourcesAudioUrl || !isPlayableSegment(seg)) return;

     // If we’re resuming the same segment, just play()—no seek.
  if (resumeIfSame && activeResourceKey === seg.key) {
  // If we've finished (or are sitting at the end), restart from the segment's start.
  if (a.currentTime >= (seg.end - 0.05)) {
    a.currentTime = seg.start;
    setResourceProgress(p => ({ ...p, [seg.key]: 0 }));
  }
  a.play().catch(() => {});
  setResourceIsPlaying(true);
  return;
}

  setActiveResourceKey(seg.key);
  // If we’re switching segments or outside its window, jump to start.
  if (a.currentTime < seg.start || a.currentTime > seg.end) {
      a.currentTime = seg.start;
  }
  a.play().catch(() => {});
  setResourceIsPlaying(true);
  setResourceProgress(p => ({ ...p, [seg.key]: 0 }));
};

// Keep per-item relative progress & auto-stop at segment end
useEffect(() => {
  const a = resourcesAudioRef.current;
  if (!a) return;

  const onTime = () => {
    const seg = resourceSegments.find(s => s.key === activeResourceKey);
    if (!seg) return;

    if (a.currentTime >= seg.end) {
      stopResourcePlayback();
      a.currentTime = seg.end;
      return;
    }

    const rel = Math.max(0, a.currentTime - seg.start);
    const dur = Math.max(0, seg.end - seg.start);
    setResourceProgress(prev => ({ ...prev, [seg.key]: Math.min(rel, dur) }));
  };

  const onEnded = () => stopResourcePlayback();

  a.addEventListener("timeupdate", onTime);
  a.addEventListener("ended", onEnded);
  return () => {
    a.removeEventListener("timeupdate", onTime);
    a.removeEventListener("ended", onEnded);
  };
}, [activeResourceKey, resourceSegments, resourcesAudioUrl]);



const setSafetyCalloutsVisible = (show) => {
  if (!safetyCalloutsRef.current) return;
  safetyCalloutsRef.current.forEach(ov => {
    if (!ov) return;
    ov.setMap(show ? mapRef.current : null);
  });
};

// Create (or update) a polyline for a link id with a given color
const ensureLinkPolyline = (linkId, color = "#186EE3") => {
  const id = String(linkId);
  const map = mapRef.current;
  if (!map) return null;

  let poly = storyboardLinkPolysRef.current.get(id);
  if (!poly) {
    const wkt = linkGeomsRef.current[id];
    if (!wkt) return null;
    const coords = wkt
      .replace(/^LINESTRING\s*\(/i, "")
      .replace(/\)$/, "")
      .split(",")
      .map(pt => {
        const [lng, lat] = pt.trim().split(" ").map(Number);
        return { lat, lng };
      });

    poly = new window.google.maps.Polyline({
      path: coords,
      geodesic: true,
      strokeColor: color,
      strokeOpacity: 1,
      strokeWeight: 5,
      zIndex: 1000,
      clickable: false
    });
    storyboardLinkPolysRef.current.set(id, poly);
  }

  poly.setOptions({ strokeColor: color, strokeOpacity: 1 });
  if (!poly.getMap()) poly.setMap(map);
  return poly;
};

// Create (or update) a marker for a node id
const ensureNodeMarker = (nodeId, { iconUrl, color } = {}) => {
  const id = String(nodeId);
  const map = mapRef.current;
  if (!map || !graphData?.nodes?.[id]) return null;

  let marker = storyboardNodeMarkersRef.current.get(id);
  const { lat, lng } = graphData.nodes[id];

  const makeIcon = () => {
    if (iconUrl) {
      return {
        url: iconUrl,
        scaledSize: new window.google.maps.Size(40, 40),
        anchor: new window.google.maps.Point(20, 20),
      };
    }
    // simple colored dot if no icon
    const pinSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="${color || "#186EE3"}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" />
      </svg>`;
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(pinSvg),
      scaledSize: new window.google.maps.Size(24, 24),
      anchor: new window.google.maps.Point(12, 12),
    };
  };

  if (!marker) {
    marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon: makeIcon(),
      opacity: 1,
    });
    storyboardNodeMarkersRef.current.set(id, marker);
  } else {
    marker.setPosition({ lat, lng });
    marker.setIcon(makeIcon());
    if (!marker.getMap()) marker.setMap(map);
  }
  return marker;
};

const ensureCustomMarker = ({ key, lat, lng, iconUrl, color }) => {
  const map = mapRef.current;
  if (!map || typeof lat !== "number" || typeof lng !== "number") return null;

  const id = String(key || `latlng:${lat},${lng}`);
  let marker = storyboardNodeMarkersRef.current.get(id);

  const makeIcon = () => {
    if (iconUrl) {
      return {
        url: iconUrl,
        scaledSize: new window.google.maps.Size(60, 60),
        anchor: new window.google.maps.Point(20, 20),
      };
    }
    const pinSvg = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="${color || "#186EE3"}" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="8" />
      </svg>`;
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(pinSvg),
      scaledSize: new window.google.maps.Size(24, 24),
      anchor: new window.google.maps.Point(12, 12),
    };
  };

  if (!marker) {
    marker = new window.google.maps.Marker({
      position: { lat, lng },
      map,
      icon: makeIcon(),
      opacity: 1,
    });
    storyboardNodeMarkersRef.current.set(id, marker);
  } else {
    marker.setPosition({ lat, lng });
    marker.setIcon(makeIcon());
    if (!marker.getMap()) marker.setMap(map);
  }
  return marker;
};

// Hide everything created by the storyboard
const hideAllStoryboardOverlays = () => {
  storyboardLinkPolysRef.current.forEach(poly => poly.setMap(null));
  storyboardNodeMarkersRef.current.forEach(m => m.setMap(null));
  storyboardFirePolysRef.current.forEach(p => p.setMap(null)); 
  storyboardFirePolysRef.current = [];
  storyboardSmokeOverlaysRef.current.forEach(overlay => overlay?.setMap(null));
  storyboardSmokeOverlaysRef.current.clear();
  sceneTimeOverlaysRef.current.forEach(ov => ov && ov.setMap(null));
  sceneTimeOverlaysRef.current = [];                         
};

const showSceneDestTimes = (scene) => {
    // Remove any previous labels from prior scenes
    sceneTimeOverlaysRef.current.forEach(ov => ov && ov.setMap(null));
    sceneTimeOverlaysRef.current = [];
  
    const activeId = activeRouteNodeRef.current;
    if (!scene?.destTimes || !activeId) return;
  
    scene.destTimes.forEach(dt => {
      const id = String(dt.nodeId);
      if (String(activeId) !== id) return; // only show for active destination
  
      // Find the drawn destination to place the label at the same position
      const r = (routesDataRef.current || []).find(
        rd => String(rd.destNodeId) === id
      );
      if (!r || !r.destinationPos) return;
  
      const ov = createTextOverlay(r.destinationPos, String(dt.time));
      sceneTimeOverlaysRef.current.push(ov);
    });
  };

// Apply a storyboard "scene" object { camera, links[], nodes[], ... }
const applyStoryboardScene = (scene) => {
  if (!scene) return;

  // Camera (smooth if changed)
  if (scene.camera && mapRef.current) {
    const { center, zoom } = scene.camera;
    const last = lastStoryboardCameraRef.current;
    const changed =
      !last ||
      Math.abs((last.center?.lat ?? 0) - center.lat) > 1e-6 ||
      Math.abs((last.center?.lng ?? 0) - center.lng) > 1e-6 ||
      (last.zoom !== zoom);

    if (changed) {
      modifyMapCamera(mapRef.current, center, zoom, 1000);
      lastStoryboardCameraRef.current = { center, zoom };
    }
  }

  // LINKS: force red + high z-index unless overridden in scene
  const visibleLinks = new Set();
  (scene.links || []).forEach(l => {
    const poly = ensureLinkPolyline(l.id, l.color || "#FF0000");
    if (poly) {
      poly.setOptions({
        strokeColor: l.color || "#FF0000",
        zIndex: typeof l.zIndex === "number" ? l.zIndex : 9999,
        strokeOpacity: 1
      });
      visibleLinks.add(String(l.id));
    }
  });
  storyboardLinkPolysRef.current.forEach((poly, id) => {
    if (!visibleLinks.has(id)) poly.setMap(null);
  });

  // Markers (nodes + custom icons share one registry)
  const visibleMarkerKeys = new Set();

  // Legacy node markers still supported
  (scene.nodes || []).forEach(n => {
    const marker = ensureNodeMarker(n.nodeId, { iconUrl: n.iconUrl, color: n.color });
    if (marker) visibleMarkerKeys.add(String(n.nodeId));
  });

  // NEW: icons by lat/lng; currently supports { type: "flag", lat, lng, key? }
  (scene.icons || []).forEach(icon => {
      if (typeof icon.lat !== "number" || typeof icon.lng !== "number") return;
      const type = String(icon.type || "flag").toLowerCase();
      const iconUrl =
        type === "parking" ? ParkingIconGreen : /* school uses flag too */ SafetyIcon;
      const key = String(icon.key || `${type}:${icon.lat},${icon.lng}`);
      const marker = ensureCustomMarker({
        key,
        lat: icon.lat,
          lng: icon.lng,
          iconUrl
        });
        if (marker) visibleMarkerKeys.add(key);
      });

  // Hide any storyboard markers not declared in this scene
  storyboardNodeMarkersRef.current.forEach((m, id) => {
    if (!visibleMarkerKeys.has(id)) m.setMap(null);
  });

  storyboardFirePolysRef.current.forEach(p => p.setMap(null));
  storyboardFirePolysRef.current = [];

  if (scene.firePolygons && scene.firePolygons.length && mapRef.current) {
    // Reuse an existing fire color (latest/highest zIndex one if present)
    const baseColor = (firePolygons && firePolygons[0] && firePolygons[0].color) || "rgb(255,69,0)";
    const visibleSmokeKeys = new Set();

    scene.firePolygons.forEach(fp => {
      if (!Array.isArray(fp?.path) || fp.path.length < 3) return;

      const smokePath = translatePolygonToCenter(fp.path, FR_FIRE_SMOKE_CENTER);
      if (smokePath.length >= 3) {
        const smokePayload = {
          ...fp,
          path: smokePath,
          wind: fp.wind || FR_FIRE_SMOKE_WIND,
          density: fp.density || FR_FIRE_SMOKE_DENSITY
        };
        const smokeKey = getSmokeOverlayKey(smokePayload);
        visibleSmokeKeys.add(smokeKey);

        if (!storyboardSmokeOverlaysRef.current.has(smokeKey)) {
          const overlay = createSmokeEmberOverlay({
            google: window.google,
            map: mapRef.current,
            path: smokePath,
            wind: smokePayload.wind,
            density: smokePayload.density
          });
          if (overlay) storyboardSmokeOverlaysRef.current.set(smokeKey, overlay);
        }
      }

      const polygon = new window.google.maps.Polygon({
        paths: fp.path,
        fillColor: baseColor,
        fillOpacity: 0.8,
        strokeColor: baseColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        map: mapRef.current,
        zIndex: 9998
      });
      storyboardFirePolysRef.current.push(polygon);
    });

    storyboardSmokeOverlaysRef.current.forEach((overlay, smokeKey) => {
      if (!visibleSmokeKeys.has(smokeKey)) {
        overlay?.setMap(null);
        storyboardSmokeOverlaysRef.current.delete(smokeKey);
      }
    });
  } else {
    storyboardSmokeOverlaysRef.current.forEach(overlay => overlay?.setMap(null));
    storyboardSmokeOverlaysRef.current.clear();
  }

  showSceneDestTimes(scene);
};

// Given a current time (seconds), find the scene and apply it
const applyStoryboardForTime = (tSec) => {
  const scenes = activeScenesRef.current || [];
  if (!scenes.length) {
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setActiveCallout(null);
    setBalloonsSpec(null);
    setActiveHeroUrl(null);
    CLEAR_TRAFFIC_OVERRIDE();
    return;
  }
  const scene = scenes.find(s => tSec >= s.start && tSec < s.end);
  if (!scene) {
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setActiveCallout(null);
    setBalloonsSpec(null);
    setActiveHeroUrl(null);
    CLEAR_TRAFFIC_OVERRIDE();
    return;
  }
  applyStoryboardScene(scene);
  setActiveCallout(scene.callout || null);
  setBalloonsSpec(scene.balloons || null);

  if (scene.showHeroImage && scene.showHeroImage.imageName) {
    const key = String(scene.showHeroImage.imageName);
    const url = heroImages[key];
    setActiveHeroUrl(url || null);
  } else {
    setActiveHeroUrl(null);
  }

  if (scene.trafficAnimation) {
    APPLY_TRAFFIC_OVERRIDE(scene.trafficAnimation);
    // If the scene’s congestion color is “red”, drive queues from route tables.
    const col = String(scene.trafficAnimation.color || "").toLowerCase();
    if (col.includes("ff0000") || col.includes("red")) {
      APPLY_LATE_QUEUE_COUNTS();
    } else {
      CLEAR_QUEUE_OVERRIDE();
    }
  } else {
    CLEAR_TRAFFIC_OVERRIDE();
    CLEAR_QUEUE_OVERRIDE();
  }
};


  // Fetch podcast audio URL on mount.
  useEffect(() => {
    const storage = getStorage();
    const podcastRefStorage = storageRef(storage, 'Podcast media/street-podcasts/Lakeview-drive/Lakeview-Drive_1760738279.mp3');
    getDownloadURL(podcastRefStorage)
      .then((url) => { setPodcastAudioUrl(url); })
      .catch((error) => { console.error("Error fetching podcast audio:", error); });

  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;
  
    // Clear out any previous graph data immediately
    setGraphData({ links: [], nodes: {}, adjList: {} });
  
    const storage = getStorage();
    const csvRef = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_links.csv`
    );
  
    getDownloadURL(csvRef)
      .then(url => fetch(url))
      .then(response => response.text())
      .then(csvText => {
        const parsed = parseCSV(csvText);
  
        const nodes = {};
        parsed.forEach(row => {
          const startId = row.start_node_id;
          const endId   = row.end_node_id;
          const geom    = row.geometry
            .replace(/LINESTRING\s*\(/, '')
            .replace(/\)$/, '');
          const coordsArr = geom
            .split(',')
            .map(s => s.trim().split(' ').map(Number));
  
          if (coordsArr.length) {
            const [lng0, lat0] = coordsArr[0];
            const [lngN, latN] = coordsArr[coordsArr.length - 1];
            nodes[startId] = { id: startId, lat: lat0, lng: lng0 };
            nodes[endId]   = { id: endId,   lat: latN, lng: lngN };
          }
        });
  
        const adjList = {};
        parsed.forEach(row => {
          const start  = row.start_node_id;
          const end    = row.end_node_id;
          const length = parseFloat(row.length);
  
          if (!adjList[start]) adjList[start] = [];
          if (!adjList[end])   adjList[end]   = [];
  
          adjList[start].push({ node: end, weight: length, link: row });
        });

        console.log(parsed)
  
        setGraphData({ links: parsed, nodes, adjList });

        // Keep global WKT lookup in sync for storyboard
        const linkGeoms = {};
        parsed.forEach(row => {
          linkGeoms[row.link_id] = row.geometry;
        });
        linkGeomsRef.current = linkGeoms;
      })
      .catch(error => console.error('Error fetching CSV:', error));

      fetchAllFireData(selectedSimulation.id)
  }, [selectedSimulation]);

  useEffect(() => {
    const fetchSimulations = async () => {
      try {
        const simsCol   = collection(firestore, 'simulations');
        const simDocs   = await getDocs(simsCol);
        const simList   = simDocs.docs.map(d => ({ id: d.id, ...d.data() }));
        setSimulations(simList);
        if (simList.length) {
          const preferred = simList.find(s => s.name === "FR_N_B19_podcast_2" || s.id === "FR_N_B19_podcast_2");   
          setSelectedSimulation(preferred || simList[simList.length - 1]);
        }
      } catch (err) {
        console.error('Error fetching simulations:', err);
      }
    };
    fetchSimulations();
  }, []);

  useEffect(() => {
    if (!selectedSimulation) return;                       // need the ID
  
    const storage = getStorage();
    const nodesRef = storageRef(
      storage,
      `${selectedSimulation.id}/inputs/berkeley_nodes.csv`
    );
  
    getDownloadURL(nodesRef)
      .then(url => fetch(url))
      .then(res => res.text())
      .then(csv => {
        const rows = parseCSV(csv);                        // you already have parseCSV
        const dests = rows
          .filter(r => r.type === 'destination')
          .map(r => ({ nodeId: r.node_id, name: r.name || r.node_id }));
        setDestinationNodes(dests);                        // update state
      })
      .catch(err => console.error('Error loading nodes CSV:', err));
  }, [selectedSimulation]);
  

useEffect(() => {
  if (selectedTab !== "routes") {
    STOP_ANIMS();    
    updateRouteOpacity(null);
    hideAllStoryboardOverlays();
    lastStoryboardCameraRef.current = null;
    setIsPodcastPlaying(false);
    setSafetyCalloutsVisible(true);
    setBalloonsSpec(null);
    setActiveCallout(null);
  }
}, [selectedTab]);

  // Fetch and parse CSV file on mount.
  useEffect(() => {
    const storage = getStorage();
    const csvRef = storageRef(storage, 'simulation_output_1753641819/inputs/berkeley_links.csv');
    getDownloadURL(csvRef)
      .then(url => fetch(url))
      .then(response => response.text())
      .then(csvText => {
        const parsed = parseCSV(csvText);
        let nodes = {};
        parsed.forEach(row => {
          const startId = row.start_node_id;
          const endId = row.end_node_id;
          const geom = row.geometry;
          const coordsString = geom.replace(/LINESTRING\s*\(/, '').replace(/\)$/, '');
          const coordsArr = coordsString.split(',').map(s => s.trim().split(' ').map(Number));
          if (coordsArr.length > 0) {
            if (!nodes[startId]) {
              nodes[startId] = { id: startId, lat: coordsArr[0][1], lng: coordsArr[0][0] };
            }
            if (!nodes[endId]) {
              nodes[endId] = { id: endId, lat: coordsArr[coordsArr.length - 1][1], lng: coordsArr[coordsArr.length - 1][0] };
            }
          }
        });
        let adjList = {};
        parsed.forEach(row => {
          const start = row.start_node_id;
          const end = row.end_node_id;
          const length = parseFloat(row.length);
          if (!adjList[start]) adjList[start] = [];
          if (!adjList[end]) adjList[end] = [];
          adjList[start].push({ node: end, weight: length, link: row });
        });
        setGraphData({ links: parsed, nodes, adjList });
      })
      .catch(error => console.error("Error fetching CSV:", error));
  }, []);

  // CSV parser helper.
  const parseCSV = (text) => {
    const lines = text.split('\n').filter(line => line.trim() !== '');
    const header = lines[0].split(',');
    const data = [];
    const regex = /,(?=(?:(?:[^"]*"){2})*[^"]*$)/;
    for (let i = 1; i < lines.length; i++) {
      let row = lines[i].split(regex);
      const obj = {};
      header.forEach((col, index) => {
        obj[col] = row[index] ? row[index].replace(/^"|"$/g, '') : '';
      });
      data.push(obj);
    }
    return data;
  };

  const clearFireSmokeOverlays = () => {
    fireSmokeOverlaysRef.current.forEach(overlay => overlay?.setMap?.(null));
    fireSmokeOverlaysRef.current = [];
  };

  const getPolygonCenter = (path) => {
    if (!Array.isArray(path) || !path.length) return null;
    const totals = path.reduce(
      (acc, pt) => ({
        lat: acc.lat + Number(pt.lat || 0),
        lng: acc.lng + Number(pt.lng || 0)
      }),
      { lat: 0, lng: 0 }
    );
    return {
      lat: totals.lat / path.length,
      lng: totals.lng / path.length
    };
  };

  const translatePolygonToCenter = (path, targetCenter) => {
    const center = getPolygonCenter(path);
    if (!center) return [];

    const latOffset = targetCenter.lat - center.lat;
    const lngOffset = targetCenter.lng - center.lng;

    return path
      .map((pt) => {
        const lat = Number(pt.lat);
        const lng = Number(pt.lng);
        const translatedLat = lat + latOffset;

        return {
          lat: targetCenter.lat + Math.max(0, translatedLat - targetCenter.lat) * FR_FIRE_SMOKE_NORTH_EXPANSION + Math.min(0, translatedLat - targetCenter.lat),
          lng: lng + lngOffset
        };
      })
      .filter((pt) => Number.isFinite(pt.lat) && Number.isFinite(pt.lng));
  };

  const setFireSmokeOverlayFromPolygon = (firePolygon) => {
    clearFireSmokeOverlays();

    if (!mapRef.current || !window.google || !Array.isArray(firePolygon?.path)) return;

    const smokePath = translatePolygonToCenter(firePolygon.path, FR_FIRE_SMOKE_CENTER);
    if (smokePath.length < 3) return;

    const overlay = createSmokeEmberOverlay({
      google: window.google,
      map: mapRef.current,
      path: smokePath,
      wind: FR_FIRE_SMOKE_WIND,
      density: FR_FIRE_SMOKE_DENSITY
    });

    if (overlay) fireSmokeOverlaysRef.current = [overlay];
  };

  const clearAndSetFirePolygons = (polys) => {
    const map = mapRef.current;
    // remove any existing
    firePolygonsRef.current.forEach(p => p && p.setMap(null));
    firePolygonsRef.current = [];
    clearFireSmokeOverlays();
  
    // draw the new ones
    polys.forEach((p, idx) => {
      const polygon = new window.google.maps.Polygon({
        paths: p.path,
        fillColor: p.color,
        fillOpacity: 0.8,
        strokeColor: p.color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        map,
        zIndex: idx
      });
      firePolygonsRef.current.push(polygon);
    });

    if (polys.length) setFireSmokeOverlayFromPolygon(polys[0]);
  
    setFirePolygons(polys);
  };

  const fetchAllFireData = async (simulationId) => {
       const storage    = getStorage();
       const prefixRef  = storageRef(storage, `${simulationId}/fire_inputs/`);
       const listResult = await listAll(prefixRef);
    
       // 1) load every geojson file
       const rawPolys = [];
       await Promise.all(
         listResult.items
           .filter(item => item.name.endsWith(".geojson"))
           .map(async item => {
             const m = item.name.match(/fire_(\d+)\.geojson$/);
             if (!m) return;
             const time = parseInt(m[1], 10);
             const url  = await getDownloadURL(item);
             const json = await (await fetch(url)).json();
             (json.features || []).forEach(f => {
               rawPolys.push({
                 time,
                 path: f.geometry.coordinates[0].map(([lng,lat])=>({lat,lng}))
               });
             });
           })
       );
    
       // 2) dedupe identical shapes
       const seen = new Set();
       const uniq = [];
       rawPolys.forEach(p => {
         const key = JSON.stringify(p.path);
         if (!seen.has(key)) {
           seen.add(key);
           uniq.push(p);
         }
       });
    
       if (uniq.length === 0) {
         clearAndSetFirePolygons([]);
         return;
       }
    
       // 3) sort by time descending (latest first)
       uniq.sort((a,b) => b.time - a.time);
    
       // 4) assign a colour gradient yellow→red
       const N = uniq.length;
       uniq.forEach((p,i) => {
         const t   = (N-1-i) / (N - 1 || 1);
         const g   = Math.round(255 - (255 - 69) * t);
         p.color   = `rgb(255,${g},0)`;
       });
    
       // 5) draw stacked
       clearAndSetFirePolygons(uniq);
     };
  
  

  const handleGetTravelExperience = async () => {
    if (!selectedLocation) {
      window.alert(
        addressFlowErrors.selectMapStartPoint || 'Click on the map first to choose your starting point.'
      );
      return;
    }

    console.log("Here graphdata2", graphData)
  
    try {
      const exp = await getTravelExperiencesV2({
        lat: selectedLocation.lat,
        lng: selectedLocation.lng,
        graphData,
        destinationNodes,
        selectedTime: Number(time),
        simulation: selectedSimulation,
        apiAbortSignal: apiCallControllerRef.current?.signal
      });
      console.log('Travel experience log:', exp);
      setTravelExperiences(exp);

      const narrative = buildTravelNarrativeV2(exp, selectedLocation, Number(time));
      setTravelExpNarrativeStream(narrative);

      
      /* 
      
      const uploadPoint = Date.now();
  
      await getTravelExperienceEnglishSummary(
        exp,
        selectedLocation,
        Number(time),
        uploadPoint
      );


      const db = getDatabase();
      const evac_experience_content_ref = ref(
        db,
        `/generated_narrative/${uploadPoint}`
      );
      onValue(evac_experience_content_ref, (snapshot) => {
        const val = snapshot.val();
        console.log(val)
        if (val && typeof val === "string") {
          setTravelExpNarrativeStream(val);       // reuse existing audio/text display
        }
      });
      */

    } catch (err) {
      console.error('Could not get travel experience', err);
    }
  };

  const handlePlayAgain = () => {
    setShowNextSteps(false);           // close the dialog
    clearPauseTimer();                 // clear any pending pause logic
    logPodcastAction({
      platform: isMobile?'mobile':'web',
      action: 'interactive_map_audio_replay',
      cta: '',
      node: String(nearestNodeIdRef.current || ''),
      chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
      param_lang: selectedLanguage,
      podcast: selectedSimulation?.name || ''
    });
    const a = routesAudioRef.current;
    if (a) {
      a.currentTime = 0;               // restart from the beginning
      playWithDisclaimer({ restart: true }).catch(() => {});
    }
  };
 

  // Function to play podcast audio.
  const playSection = (startTime) => {
    if (podcastAudioRef.current) {
      podcastAudioRef.current.currentTime = startTime;
      podcastAudioRef.current.play();
    }
  };

  const playRouteSection = (startTime) => {
    if (routesAudioRef.current) {
      routesAudioRef.current.currentTime = startTime;
      routesAudioRef.current.play();
    }
  };

  const createTextOverlay = (position, text) => {
    const overlay = new window.google.maps.OverlayView();
    overlay.onAdd = function() {
      this.div = document.createElement("div");
      // Style the overlay div as desired:
      this.div.style.position = "absolute";
      this.div.style.background = "rgba(255, 255, 255, 0.9)";
      this.div.style.color = "#000";
      this.div.style.padding = "2px 4px";
      this.div.style.borderRadius = "4px";
      this.div.style.fontSize = "16px";
      this.div.innerHTML = text;
      const panes = this.getPanes();
      panes.floatPane.appendChild(this.div);
    };
    overlay.draw = function() {
      const projection = this.getProjection();
      // Convert the geographical position to pixel coordinates.
      const point = projection.fromLatLngToDivPixel(new window.google.maps.LatLng(position.lat, position.lng));
      if (point && this.div) {
        // Adjust the position so the overlay appears centered above the marker.
        this.div.style.left = (point.x - this.div.offsetWidth / 2) + "px";
        this.div.style.top = (point.y - this.div.offsetHeight - 20) + "px"; // 5px above
      }
    };
    overlay.onRemove = function() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    };
    overlay.setMap(mapRef.current);
    return overlay;
  };

  const apiCallControllerRef = useRef(null);

  const drawRoutes = async (lat, lng, selectedTime, selectedSimulation, dests) => {
    if (!dests || dests.length === 0) return;
  
    // Abort any ongoing calls
    if (apiCallControllerRef.current) apiCallControllerRef.current.abort();
    apiCallControllerRef.current = new AbortController();
  
    // Location marker
    if (circleRef.current) circleRef.current.setMap(null);
    const locationMarker = new window.google.maps.Marker({
      position: { lat, lng },
      map: mapRef.current,
      icon: GET_HOUSE_MARKER_ICON(),
    });
    circleRef.current = locationMarker;
  
    // Clear old overlays
    STOP_ANIMS(); 
    polylineRefs.current.forEach(poly => poly.setMap(null));
    polylineRefs.current = [];
    carMarkersRef.current.forEach(marker => marker.setMap(null));
    carMarkersRef.current = [];
    routesDataRef.current = [];
    if (safetyCalloutsRef.current && safetyCalloutsRef.current.length > 0) {
      safetyCalloutsRef.current.forEach(callout => callout.setMap(null));
      safetyCalloutsRef.current = [];
    }
    if (sceneTimeOverlaysRef.current && sceneTimeOverlaysRef.current.length > 0) {
        sceneTimeOverlaysRef.current.forEach(ov => ov && ov.setMap(null));
        sceneTimeOverlaysRef.current = [];
      }
  
    if (!graphData.nodes || Object.keys(graphData.nodes).length === 0) {
      wantRoutesAutoplayRef.current = false;
      logRoutePlaybackDiagnostic("interactive_map_route_setup_failed", "graph_unavailable");
      return;
    }
  
    // Build link geometry lookup
    const linkGeoms = {};
    (graphData.links || []).forEach(row => { linkGeoms[row.link_id] = row.geometry; });
    linkGeomsRef.current = linkGeoms;
  
    // Find nearest node to click
    const { nearestNodeId } = pickNearestGraphNode({
            lat,
            lng,
            graphData,
            k: 6,
            podcastNodeIds,
            // use your link length as weight (already in your adjList edges)
            weightAccessor: (edge) => Number(edge.weight || edge.link?.length || 0),
            // optional street tie-breakers using your existing helpers
            streetText: extractStreetFromInput(searchText),
            linkStreetName,
            streetSimilarity,
          });

      console.log("Nearest node", nearestNodeId)

    if (nearestNodeId == null) {
      wantRoutesAutoplayRef.current = false;
      logRoutePlaybackDiagnostic("interactive_map_route_setup_failed", "nearest_node_unavailable", "");
      return;
    }

    nearestNodeIdRef.current = nearestNodeId;

    // ⬇️ NEW: snap selectedLocation + marker to the nearest node
    const nn =
    graphData.nodes[nearestNodeId] || graphData.nodes[String(nearestNodeId)];
    if (nn) {
    setSelectedLocation({ lat: nn.lat, lng: nn.lng });
    if (circleRef.current) {
      circleRef.current.setPosition({ lat: nn.lat, lng: nn.lng });
    }
    }

    loadRouteTableForNode(nearestNodeId);
  
    // ---- NEW LOGIC (modular): pick two closest destinations with route diversity ----
    const selectedRoutes = selectTwoDiverseRoutes({
      graphData,
      nearestNodeId,
      dests,
      selectedTime
    });
    if (!selectedRoutes || selectedRoutes.length === 0) {
      wantRoutesAutoplayRef.current = false;
      logRoutePlaybackDiagnostic("interactive_map_route_setup_failed", "routes_unavailable", nearestNodeId);
      return;
    }
  
    // ---- Everything below remains the same, but iterate over selectedRoutes instead of dests ----
    const routesData = [];
  
    for (const sel of selectedRoutes) {
      const route = sel.node_path;
      const routeCoords = route.map(nodeId => {
        const node = graphData.nodes[nodeId];
        return { lat: node.lat, lng: node.lng };
      });
  
      const pathLinks = sel.link_ids || [];
  
      // Draw true geometry per link
      const routePolylines = pathLinks.map(linkId => {
        const wkt = linkGeoms[linkId];
        if (!wkt) return null;
        const coords = wkt
          .replace(/^LINESTRING\s*\(/i, '')
          .replace(/\)$/, '')
          .split(',')
          .map(pt => {
            const [lng2, lat2] = pt.trim().split(' ').map(Number);
            return { lat: lat2, lng: lng2 };
          });
  
        return new window.google.maps.Polyline({
          path: coords,
          geodesic: true,
          strokeColor: "#186EE3",
          strokeOpacity: 0.35,
          strokeWeight: 5,
          zIndex: -1000,
          clickable: true
        });
      }).filter(Boolean);
  
      // Put on map & wire clicks
      routePolylines.forEach((poly, idx) => {
        poly.setMap(mapRef.current);
        const linkId = pathLinks[idx];
        poly.addListener("click", () => console.log(`Link ID: ${linkId}`));
        polylineRefs.current.push(poly);
      });
  
      // Destination marker
      const destinationPos = routeCoords[routeCoords.length - 1];
      const destMarker = new window.google.maps.Marker({
        position: destinationPos,
        map: mapRef.current,
        icon: { url: SafetyIcon, scaledSize: new window.google.maps.Size(40, 40), anchor: new window.google.maps.Point(20, 20) },
        opacity: 1
      });
      destMarker.addListener('click', () => console.log(`Destination node ID: ${sel.nodeId}`));


      // Hospital marker
      if (!hospitalMarkerRef.current) {

        let marker = new window.google.maps.Marker({
          position: { lat: 37.715885, lng: -122.130340 },
          map: mapRef.current,
          icon: {
            url: HospitalIcon,
            scaledSize: new window.google.maps.Size(48, 48),
            anchor: new window.google.maps.Point(24, 24),
          },
          title: "Hospital",
        });

        hospitalMarkerRef.current = marker
  
      } else {
        hospitalMarkerRef.current.setMap(mapRef.current);
      }
  
      // Store for API update
      routesData.push({
        destNodeId: sel.nodeId,
        pathLinks,
        routePolylines,
        destinationPos,
        destMarker
      });
    }
  
    routesDataRef.current = routesData;

    const chosenNodeId = nearestNodeId;
    // clear any previous audio/scenes so stale autoplay can't happen
    clearRoutesPodcast();

    let bundleLoaded = false;
    if (chosenNodeId) {
      try {
        await loadRouteBundleFromFirestore(chosenNodeId, selectedLanguage);
        bundleLoaded = true;
      } catch (e) {
        wantRoutesAutoplayRef.current = false;
        console.error("Failed to load route bundle:", e);
        logRoutePlaybackDiagnostic(
          "interactive_map_route_setup_failed",
          `media_bundle_load_failed:${e?.name || "error"}`,
          chosenNodeId
        );
      }
    }

    if (bundleLoaded && routesData.length > 0) {
      logRoutePlaybackDiagnostic("interactive_map_route_setup_succeeded", "route_and_media_ready", chosenNodeId);
    }

    // onCanPlay normally owns autoplay; this covers already-ready media.
    if (bundleLoaded && routesData.length > 0 && routesAudioRef.current && routesAudioUrl) {
      void attemptRoutesAutoplay("routes_draw_complete");
    }
  
    // Fire API calls concurrently (unchanged)
     routesData.forEach((routeData) => {
         const destId = String(routeData.destNodeId);
         const qmap = onTimeQueuesByDestRef.current.get(destId) || new Map();
      
         // Per-link animations + queues
         routeData.pathLinks.forEach((linkId, idx) => {
           const poly = routeData.routePolylines[idx];
           if (!poly) return;
           const queuedCount = Number(qmap.get(String(linkId)) || 0);
           // Animate link (free-flow dots). No per-link travel time, so use a steady pace.
           START_LINK_ANIM(poly, "#186EE3", 5, linkId);
           // Queue dots from on-time data
           SET_LINK_QUEUE(poly, queuedCount, 4, undefined, { animate: false, duration: 0 });
         });
      
         // Destination total time label from "leaveOnTime"
         const totalSec = Number(onTimeTotalsByDestRef.current.get(destId) || 0);
         const label = totalSec
           ? formatTime(totalSec, { style: "digital" })
           : (routeTableRows.find(r => String(r.id) === destId)?.leaveOnTime || "");
      
         const textOverlay = createTextOverlay(routeData.destinationPos, label);
         const isPlayingNow = !!routesAudioRef.current && !routesAudioRef.current.paused;
         if (isPlayingNow) textOverlay.setMap(null);
         safetyCalloutsRef.current.push(textOverlay);
      });
  };

  const finishAddressEntryFlow = async (addressLabel = "") => {
    if (addressLabel) setResolvedAddressLabel(addressLabel);
    setAddressEntryMode("ready");
    await new Promise((resolve) => setTimeout(resolve, 650));
    if (autoplayOutcomeRef.current === "blocked") return;
    setShowAddressEntryFlow(false);
    setAddressEntryMode("form");
    setAddressSuggestions([]);
    setAddressEntryError("");
    setIsPickOnMapMode(false);
  };

  const applyLocationSelection = async (lat, lng, { addressLabel = "", logEndSearch = false, ctaValue = "" } = {}) => {
    const latNum = Number(lat);
    const lngNum = Number(lng);

    if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) {
      throw new Error("Could not find this location.");
    }

    setSelectedLocation({ lat: latNum, lng: lngNum });

    if (logEndSearch) {
      logPodcastAction({
        platform: isMobile ? "mobile" : "web",
        action: "location_search_end",
        cta: ctaValue,
        chapter: String(String(nearestNodeIdRef.current || "") + "_" + selectedLanguage),
        param_lang: selectedLanguage,
        podcast: selectedSimulation?.name || ""
      });
    }

    if (mapRef.current) {
      modifyMapCamera(
        mapRef.current,
        { lat: latNum, lng: lngNum },
        15,
        1000
      );
    }

    if (selectedSimulation) {
      wantRoutesAutoplayRef.current = true;
      logRoutePlaybackDiagnostic("interactive_map_route_setup_started", "address_selected");
      await drawRoutes(latNum, lngNum, time, selectedSimulation, destinationNodes);
    } else {
      wantRoutesAutoplayRef.current = false;
      logRoutePlaybackDiagnostic("interactive_map_route_setup_failed", "simulation_unavailable");
    }

    await finishAddressEntryFlow(addressLabel);
  };

  const handleMapClick = async (e) => {
    // If the main podcast is playing, ignore clicks (don’t start a new location/routes)
    if (routesAudioRef.current && !routesAudioRef.current.paused) {
      return;
    }

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const pickedLabel = `${lat.toFixed(5)}, ${lng.toFixed(5)}`;

    console.log("Map clicked at:", { lat, lng, time, selectedSimulation });

    if (isPickOnMapMode) {
      setShowAddressEntryFlow(true);
      setAddressEntryMode("loading");
      setAddressEntryError("");
    }

    try {
      await applyLocationSelection(lat, lng, { addressLabel: pickedLabel });
    } catch (err) {
      console.error("Map pick failed:", err);
      setAddressEntryMode("form");
      setAddressEntryError(
        addressFlowErrors.mapPointInvalid || "We could not use that map point. Try another location."
      );
      setShowAddressEntryFlow(true);
      setIsPickOnMapMode(true);
    } finally {
      setIsSearchingLoc(false);
    }
  };

  const handleUseMyLocation = () => {
    if (isSearchingLoc) return;

    if (!navigator.geolocation) {
      setAddressEntryError(
        addressFlowErrors.locationAccessUnavailable || "Location access is not available on this device."
      );
      return;
    }

    setAddressEntryError("");
    setAddressSuggestions([]);
    setAddressEntryMode("loading");
    setShowAddressEntryFlow(true);
    setIsSearchingLoc(true);

    logPodcastAction({
      platform: isMobile ? "mobile" : "web",
      action: "location_search_start",
      cta: "use_my_location",
      chapter: String(String(nearestNodeIdRef.current || "") + "_" + selectedLanguage),
      param_lang: selectedLanguage,
      podcast: selectedSimulation?.name || ""
    });

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const lat = Number(position.coords?.latitude);
          const lng = Number(position.coords?.longitude);
          await applyLocationSelection(lat, lng, {
            addressLabel: addressFlowText.currentLocationLabel || "Current location",
            logEndSearch: true,
            ctaValue: "use_my_location"
          });
        } catch (err) {
          console.error("Use my location failed:", err);
          setAddressEntryMode("form");
          setAddressEntryError(
            addressFlowErrors.currentLocationFailed || "Could not use your current location. Please enter an address."
          );
        } finally {
          setIsSearchingLoc(false);
        }
      },
      () => {
        setIsSearchingLoc(false);
        setAddressEntryMode("form");
        setAddressEntryError(
          addressFlowErrors.locationPermissionDenied || "Location permission denied. Please enter your address."
        );
      },
      { enableHighAccuracy: true, timeout: 15000 }
    );
  };

  const handleStartPickOnMap = () => {
    if (isSearchingLoc) return;
    setAddressEntryError("");
    setAddressSuggestions([]);
    setIsPickOnMapMode(true);
    setShowAddressEntryFlow(false);
  };

  const handleSuggestionPick = (suggestion) => {
    if (!suggestion?.value) return;
    setSearchText(suggestion.value);
    setAddressSuggestions([]);
    setAddressEntryError("");
    handleLocationSearch(suggestion.value);
  };



  const handleTimeChange = (e) => { 
    const newT = Number(e.target.value);
    setTime(newT);
    if (selectedLocation && selectedSimulation) {
      drawRoutes(selectedLocation.lat, selectedLocation.lng, newT, selectedSimulation, destinationNodes);
    }

  };

  const togglePolylines = () => { setShowPolyLines(!showPolyLines); };

  const handleSimulationChange = (e) => {
    const simID = e.target.value;
    console.log(simID)
    const sim = simulations.find(s => s.id === simID);
    if (sim) setSelectedSimulation(sim);

    if (selectedLocation && selectedSimulation) {
       drawRoutes(selectedLocation.lat, selectedLocation.lng, time, sim, destinationNodes);
    }
  };

  const loadFireOverlay = () => {
    // Add the fire marker here:
    // Define the fixed center and the offset in meters
    const fireCenter = { lat: 37.891993946041026, lng: -122.24859240728762 };
    const meters = 400; // adjust this value: approximately 150 meters covers 3 blocks
    const meterToDegLat = 1 / 111000; // roughly 1° latitude = 111 km
    // For longitude, adjust by the cosine of the latitude.
    const meterToDegLng = 1 / (111000 * Math.cos(fireCenter.lat * Math.PI / 180));
    const latOffset = meters * meterToDegLat;
    const lngOffset = meters * meterToDegLng;

    // Create bounds for the GroundOverlay.
    const bounds = new window.google.maps.LatLngBounds(
      new window.google.maps.LatLng(fireCenter.lat - latOffset, fireCenter.lng - lngOffset),
      new window.google.maps.LatLng(fireCenter.lat + latOffset, fireCenter.lng + lngOffset)
    );

    // Create and display the GroundOverlay using your FireImage.
    new window.google.maps.GroundOverlay(FireImage, bounds, { opacity: 0.75 }).setMap(mapRef.current);
  }

  

  const audioSegments = React.useMemo(() => {
    const timings = routeTimings || {};
    const sorted = Object.entries(timings)
      .map(([title, start]) => ({ title, start }))
      .sort((a, b) => a.start - b.start);
    sorted.forEach((seg, i) => (seg.end = i < sorted.length - 1 ? sorted[i + 1].start : Infinity));
    return sorted;
  }, [routeTimings]);
  
  const nodeIdForTime = (t) => {
    const seg = audioSegments.find(s => t >= s.start && t < s.end);
    if (!seg) return null;
    const item = activeChecklistItems.find(i => i.title === seg.title);
    return item?.nodeId ?? null;
  };

  const updateRouteOpacity = (activeNodeId) => {
    routesDataRef.current.forEach(r => {
      const isActive = activeNodeId && String(r.destNodeId) === String(activeNodeId);
  
      // Polylines: keep all on map, dim non-active
      r.routePolylines.forEach(p => {
        p.setOptions({ strokeOpacity: isActive ? 1 : (activeNodeId ? 0.05 : 1) });
        if (p.getMap() === null) p.setMap(mapRef.current);
        SET_LINK_ANIM_VISIBLE(p, !!(isActive || !activeNodeId));
      });
  
      // Destination markers: ONLY show the active one when a node is active
      if (activeNodeId) {
        if (isActive) {
          if (!r.destMarker.getMap()) r.destMarker.setMap(mapRef.current);
          r.destMarker.setOpacity(1);
        } else {
          r.destMarker.setOpacity(0.05);
        }
      } else {
        // No active node: show all again
        if (!r.destMarker.getMap()) r.destMarker.setMap(mapRef.current);
        r.destMarker.setOpacity(1);
      }
    });
  };

  const handleLocationSearch = async (rawSearchText = searchText) => {
    if (isSearchingLoc) return false;

    const ctaValue = String(rawSearchText || "").trim();
    if (!ctaValue) return false;
    const query = `${ctaValue}, Bay O Vista`;

    setAddressEntryError("");
    autoplayOutcomeRef.current = "pending";
    setAutoplayOutcome("pending");
    setAddressSuggestions([]);
    setAddressEntryMode("loading");
    setShowAddressEntryFlow(true);
    setIsPickOnMapMode(false);

    logPodcastAction({
      platform: isMobile ? "mobile" : "web",
      action: "location_search_start",
      cta: ctaValue,
      chapter: String(String(nearestNodeIdRef.current || "") + "_" + selectedLanguage),
      param_lang: selectedLanguage,
      podcast: selectedSimulation?.name || ""
    });

    try {
      setIsSearchingLoc(true);
      const { lat, lng } = await geocodeAddress(query, "", "");

      await applyLocationSelection(lat, lng, {
        addressLabel: ctaValue,
        logEndSearch: true,
        ctaValue
      });
      return true;
    } catch (err) {
      console.error("Geocode failed:", err);
      setAddressEntryMode("form");
      setAddressEntryError(
        addressFlowErrors.addressNotFound || "We could not find that address. Try selecting from the suggestions."
      );
      return false;
    } finally {
      setIsSearchingLoc(false);
    }
  };

  const modifyMapCamera = (map, endCenter, endZoom, duration = 1000) => {
    const startCenter = map.getCenter().toJSON();
    const startZoom   = map.getZoom();
    const frames      = Math.round((duration / 1000) * 60); // ~60 fps
    let frame = 0;
  
    const latDiff  = endCenter.lat - startCenter.lat;
    const lngDiff  = endCenter.lng - startCenter.lng;
    const zoomDiff = endZoom       - startZoom;
  
    const step = () => {
      frame += 1;
      const t    = frame / frames;
      const ease = t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;   // ease-in/out
  
      map.setCenter({
        lat: startCenter.lat + latDiff * ease,
        lng: startCenter.lng + lngDiff * ease
      });
      map.setZoom(startZoom + zoomDiff * ease);
  
      if (frame < frames) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  const canShowContinueCta =
    !!routesAudioUrl &&
    !!selectedLocation &&
    hasCrossed90Ref.current &&
    !isPodcastPlaying &&
    !showNextSteps;


  return (
    <div style={{ position: "relative", width: "100vw", height: "100vh", overflow: "hidden" }}>


          <div style={{ position: "relative", /* NEW wrapper */ }}>
            <div
              style={{
                position: "absolute",
                top: 10, left: 0, right: 0,
                width: "90%", maxWidth: 500, margin: "0 auto",
                zIndex: 5
              }}
            >

            {!isPodcastPlaying && (
                <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
                <h1 className="page-title-gradient"
                style={{ whiteSpace: 'nowrap', fontFamily: '"Trebuchet MS", Verdana, Tahoma, Arial, sans-serif' }}>
                  {uiText.title}
                </h1>
              </div>
              )}
              {!isPodcastPlaying && !showAddressEntryFlow && (
                <SearchBar
                  value={searchText}
                  onChange={handleSearchTextInput}
                  onSubmit={handleLocationSearch}
                  isLoading={isSearchingLoc}
                  placeholder={addressFlowText.searchBarPlaceholder || "Enter address and press Enter"}
                />
              )}

              {isDisclaimerPlaying && (
                <div
                  style={{
                    background: "#fff7ed",
                    color: "#9a3412",
                    border: "1px solid #fdba74",
                    borderRadius: 14,
                    padding: "12px 16px",
                    boxShadow: "0 8px 24px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.12)",
                    fontSize: 18,
                    fontWeight: 800,
                    textAlign: "center"
                  }}
                >
                  Safety disclaimer
                </div>
              )}

              {!isDisclaimerPlaying && isPodcastPlaying && activeCallout && (
                  <div
                  style={{
                    background: activeCallout.bg || "#fff",
                    color: activeCallout.textColor || "#111",
                    borderRadius: 14,
                    padding: "12px 16px",
                    boxShadow: "0 8px 24px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.12)",
                    fontSize: 18,         
                    lineHeight: 1.4,
                    fontFamily:
                      '"Segoe Print","Comic Sans MS","Bradley Hand","Apple Chancery","Caveat","Patrick Hand",cursive',
                    whiteSpace: "pre-line"
                  }}
                >
                  {activeCallout.text}
                </div>
                )}
            </div>

            <BalloonsOverlay
              show={!!balloonsSpec}
              count={balloonsSpec?.count ?? 15}
              emoji={balloonsSpec?.emoji ?? "🎈"}
              minDuration={balloonsSpec?.minDuration ?? 3.0}
              maxDuration={balloonsSpec?.maxDuration ?? 4.2}
              topBeyondVh={balloonsSpec?.topBeyondVh ?? 180}
            />

            <style>{`
            @keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}
            @keyframes heroRollIn {
              from { transform: translateX(-120%) rotate(-18deg); opacity: 0; }
              to   { transform: translateX(0) rotate(0deg); opacity: 1; }
            }
            @keyframes heroRollOut {
              from { transform: translateX(0) rotate(0deg); opacity: 1; }
              to   { transform: translateX(120%) rotate(18deg); opacity: 0; }
            }
            .heroFrameWrap { will-change: transform, opacity; }
            .hero-roll-in  { animation: heroRollIn 1500ms cubic-bezier(.2,.8,.2,1) both; }
            .hero-roll-out { animation: heroRollOut 1500ms cubic-bezier(.2,.8,.2,1) both; }
            `}</style>
            
            
            <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={GOOGLE_MAP_LIBRARIES}>
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={15}
                onLoad={(map) => {
                  mapRef.current = map;
                  setMapReady(true);
                }}
                onZoomChanged={UPDATE_HOUSE_MARKER_SIZE}
                onClick={handleMapClick}
                options={{
                  styles: darkMapStyle,
                  disableDefaultUI: true,
                  mapTypeControl: false,
                  zoomControl: false,
                  streetViewControl: false,
                  fullscreenControl: false,
                  scaleControl: false,
                  rotateControl: false,
                  keyboardShortcuts: false
                }}
              >
                {/* Render additional overlays, e.g., car markers via state */}
                {carOverlays}
              </GoogleMap>
            </LoadScript>

            {heroVisible && (
              <div
                className={`heroFrameWrap ${heroAnim}`}
                onAnimationEnd={() => {
                  // after the roll-out finishes, actually unmount the hero
                  if (heroAnim === 'hero-roll-out') {
                    setHeroVisible(false);
                    setHeroAnim('');
                  }
                }}
                style={{
                  position: "absolute",
                  zIndex: 6,
                  top: isPodcastPlaying ? 76 : 80,
                  bottom: 112,
                  left: 0,
                  right: 0,
                  display: "grid",
                  placeItems: "center",
                  pointerEvents: "none"
                }}
              >
                <div
                  style={{
                    // Slightly larger on mobile, unchanged on desktop
                    width: isMobile ? "min(82vh, 90vw, 880px)" : "min(68vh, 68vw, 820px)",
                    maxWidth: "92vw"
                  }}
                >
                  <HeroFrame src={activeHeroUrl || ''} alt="scene illustration" />
                </div>
              </div>
            )}

            {isPickOnMapMode && !showAddressEntryFlow && !isPodcastPlaying && (
              <div
                style={{
                  position: "absolute",
                  top: 72,
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 25,
                  background: "rgba(2, 6, 23, 0.88)",
                  color: "#f8fafc",
                  borderRadius: 999,
                  padding: "10px 16px",
                  fontSize: 14,
                  fontWeight: 700,
                  boxShadow: "0 10px 28px rgba(0,0,0,0.32)"
                }}
              >
                {addressFlowText.pickOnMapHint || "Click on the map to choose your address"}
              </div>
            )}

          

            {/* AUDIO BAR OVERLAY (bottom) */}
            {routesAudioUrl && selectedLocation && (
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 12,         
                  zIndex: 6
                }}
              >
                {/* If playing: show only Pause; if not playing: show Next Steps (when allowed) + Play */}
                {isPodcastPlaying ? (
                  <button
                    onClick={() => 
                    {
                      pauseActivePlayback()
                      logPodcastAction({
                        platform: isMobile?'mobile': 'web',
                        action: 'interactive_map_audio_pause',
                        cta: "",
                        node: String(nearestNodeIdRef.current || ''),
                        param_lang: selectedLanguage,
                        chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                        podcast: selectedSimulation?.name || ''
                      });

                    }}
                    style={{
                      background: "#f97316",
                      color: "#111827",
                      border: "none",
                      padding: "18px 28px",
                      borderRadius: 14,
                      cursor: "pointer",
                      fontWeight: 800,
                      fontSize: 20,
                      boxShadow: "0 12px 28px rgba(0,0,0,.35)",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 12
                    }}
                    aria-label="Pause"
                    title="Pause"
                  >
                    {uiText.pause}
                  </button>
                ) : (
                  <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                    {/* Always offer Play when not playing and audio is available */}
                    {routesAudioUrl && !showNextSteps && (
                      <button
                        onClick={() => {
                          playWithDisclaimer().catch(() => {});
                          setIsPodcastPlaying(true);
                          logPodcastAction({ 
                            platform: isMobile?'mobile': 'web',
                            action: 'interactive_map_audio_play',
                            cta: '',
                            chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                            node: String(nearestNodeIdRef.current || ''),
                            param_lang: selectedLanguage,
                            podcast: selectedSimulation?.name || ''
                          });
                        }}
                        style={{
                          background: "#f97316",
                          color: "#111827",
                          border: "none",
                          padding: "18px 28px",
                          borderRadius: 14,
                          cursor: "pointer",
                          fontWeight: 800,
                          fontSize: 20,
                          boxShadow: "0 12px 28px rgba(0,0,0,.35)",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 12
                        }}
                        aria-label="Play"
                        title="Play"
                      >
                        {uiText.play}
                      </button>
                    )}
                    {routesAudioUrl && !showNextSteps && (
                      <button
                        onClick={() => {
                          logPodcastAction({ 
                            platform: isMobile ? 'mobile' : 'web', 
                            action: 'next_steps_cta_click', 
                            cta: 'continue_to_next_steps', 
                            node: String(nearestNodeIdRef.current || ''), 
                            chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage), 
                            param_lang: selectedLanguage, 
                            podcast: selectedSimulation?.name || '' 
                          });
                          setShowNextSteps(true);
                        }}
                        style={{
                          background: "#f97316",
                          color: "#111827",
                          border: "none",
                          padding: "18px 28px",
                          borderRadius: 14,
                          cursor: "pointer",
                          fontWeight: 800,
                          fontSize: 20,
                          boxShadow: "0 12px 28px rgba(0,0,0,.35)",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 12
                        }}
                        aria-label="Continue to Next Steps"
                        title="Continue to Next Steps"
                      >
                        <span>{uiText.nextSteps}</span>
                        <span style={{ fontSize: 22, lineHeight: 1 }}>→</span>
                      </button>
                    )}
                    
                  </div>
                )}

                <div
                  style={{
                    width: 720,
                    maxWidth: "94vw",
                    background: "rgba(255,255,255,0.95)",
                    boxShadow: "0 8px 24px rgba(0,0,0,.18), 0 2px 8px rgba(0,0,0,.12)",
                    borderRadius: 12,
                    padding: 8
                  }}
                >
                  <audio
                    controls
                    src={routesAudioUrl}
                    ref={routesAudioRef}
                    style={{ width: "100%" }}
                    onCanPlay={(e) => {
                      clearPauseTimer();
                      e.currentTarget.playbackRate = routePlaybackRate;
                      e.currentTarget.defaultPlaybackRate = routePlaybackRate;

                      const currSrc = e.currentTarget.currentSrc || e.currentTarget.src;
                      if (currSrc !== lastAudioSrcRef.current) {
                        // New file / session -> reset once
                        hasCrossed90Ref.current = false;
                        nextStepsShownRef.current = false;
                        lastAudioSrcRef.current = currSrc;
                      }

                      void attemptRoutesAutoplay("media_can_play");
                    }}
                    onPlay={(event) => {
                      if (gateMainPlayback(event.currentTarget)) return;
                      clearPauseTimer();
                      setIsPodcastPlaying(true);
                      setSafetyCalloutsVisible(false);
                      resourcesAudioRef.current?.pause();

                      if (!hasLoggedPlayRef.current) {
                        hasLoggedPlayRef.current = true;
                        logPodcastAction({
                          platform: isMobile?'mobile': 'web',
                          action: 'interactive_map_audio_play',
                          cta: '',
                          chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                          node: String(nearestNodeIdRef.current || ''),
                          param_lang: selectedLanguage,
                          podcast: selectedSimulation?.name || ''
                        });
                      }
                    }}
                    onSeeking={() => {
                      isSeekingRef.current = true;
                      clearPauseTimer();
                    }}
                    
                    onSeeked={() => {
                      isSeekingRef.current = false;
                    }}
                    onPause={(e) => {
                      activeRouteNodeRef.current = null;
                      updateRouteOpacity(null);
                      hideAllStoryboardOverlays();
                      lastStoryboardCameraRef.current = null;
                      setIsPodcastPlaying(false);
                      setSafetyCalloutsVisible(true);
                      setActiveCallout(null);
                      setBalloonsSpec(null);
                      setActiveHeroUrl(null);
                    
                      clearPauseTimer();
                    
                      // Ignore pauses caused by scrubbing
                      if (isSeekingRef.current || e.currentTarget.seeking) return;
                    
                      const t = e.currentTarget.currentTime;

                      logPodcastAction({
                        platform: isMobile?'mobile': 'web',
                        action: 'interactive_map_audio_pause',
                        cta: String(t),
                        node: String(nearestNodeIdRef.current || ''),
                        param_lang: selectedLanguage,
                        chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                        podcast: selectedSimulation?.name || ''
                      });
                    
                      if (t >= 90 && !nextStepsShownRef.current) {
                        // Confirm it's a real pause
                        pauseTimerRef.current = setTimeout(() => {
                          const a = routesAudioRef.current;
                          if (a && a.paused && !a.seeking) {
                            setShowNextSteps(true);
                            nextStepsShownRef.current = true; // <-- stays true across future seeks
                          }
                        }, 400);
                      }
                    }}
                    onEnded={() => {
                      logPodcastAction({
                        platform: isMobile?'mobile': 'web',
                        action: 'interactive_map_audio_ended',
                        cta: '',
                        node: String(nearestNodeIdRef.current || ''),
                        chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                        param_lang: selectedLanguage,
                        podcast: selectedSimulation?.name || ''
                      });

                      clearPauseTimer();
                      activeRouteNodeRef.current = null;
                      updateRouteOpacity(null);
                      hideAllStoryboardOverlays();
                      lastStoryboardCameraRef.current = null;
                      setIsPodcastPlaying(false);
                      setSafetyCalloutsVisible(true);
                      setActiveCallout(null);
                      setBalloonsSpec(null);
                      setActiveHeroUrl(null);
                      setShowNextSteps(true);    
                      nextStepsShownRef.current = true; 
                    }}
                    onTimeUpdate={(e) => {
                      const t = e.currentTarget.currentTime;

                      if (t >= 90 && !hasCrossed90Ref.current) {
                        hasCrossed90Ref.current = true;
                        logPodcastAction({
                          platform: isMobile?'mobile': 'web',
                          action: 'interactive_map_audio_crossed_90_seconds',
                          cta: '',
                          node: String(nearestNodeIdRef.current || ''),
                          param_lang: selectedLanguage,
                          chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                          podcast: selectedSimulation?.name || ''
                        });
                      }
                      
                      if (t >= 90 && !nextStepsShownRef.current) {
                        hasCrossed90Ref.current = true;
                      }

                      const node = nodeIdForTime(t);
                      if (node !== activeRouteNodeRef.current) {
                        activeRouteNodeRef.current = node;
                        updateRouteOpacity(node);
                      }
                      applyStoryboardForTime(t);
                    }}
                  />
                </div>
              </div>
            )}


            <audio
              ref={disclaimerAudioRef}
              src={disclaimerAudioUrl}
              preload="auto"
              onEnded={handleDisclaimerEnded}
              onPlay={() => setIsPodcastPlaying(true)}
              onPause={(event) => {
                if (!event.currentTarget.ended && disclaimerPhase === "playing") {
                  setIsPodcastPlaying(false);
                }
              }}
            />

            {/* HIDDEN audio element for resource snippets (kept globally) */}
            <audio
              ref={resourcesAudioRef}
              src={resourcesAudioUrl}
              preload="metadata"
              style={{ display: "none" }}
              onPlay={() => setResourceIsPlaying(true)}
              onPause={() => setResourceIsPlaying(false)}
            />


            {showAddressEntryFlow && !isPodcastPlaying && (
              <div
                role="dialog"
                aria-modal="true"
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    isMobile && addressEntryMode === "form"
                      ? "#f3f4f6"
                      : "linear-gradient(180deg, #031f35 0%, #04314c 52%, #032c38 100%)",
                  display: "flex",
                  alignItems: isMobile && addressEntryMode === "form" ? "stretch" : "center",
                  justifyContent: isMobile && addressEntryMode === "form" ? "flex-start" : "center",
                  zIndex: 40,
                  padding:
                    isMobile && addressEntryMode === "form"
                      ? 0
                      : isMobile
                      ? "24px 16px"
                      : 24
                }}
              >
                <div
                  style={{
                    width:
                      isMobile && addressEntryMode === "form"
                        ? "100%"
                        : isMobile
                        ? "calc(100% - 32px)"
                        : "min(700px, 82vw)",
                    maxWidth: isMobile && addressEntryMode !== "form" ? 720 : "none",
                    minHeight: isMobile && addressEntryMode === "form" ? "100dvh" : "auto",
                    borderRadius: isMobile && addressEntryMode === "form" ? 0 : (isMobile ? 28 : 30),
                    background: "#f3f4f6",
                    color: "#0f172a",
                    boxShadow: isMobile && addressEntryMode === "form" ? "none" : "0 24px 62px rgba(2, 6, 23, 0.36)",
                    padding:
                      isMobile && addressEntryMode === "form"
                        ? "22px 24px 30px"
                        : isMobile
                        ? "26px 22px 30px"
                        : "40px 48px 42px",
                    overflowY: isMobile && addressEntryMode === "form" ? "auto" : "visible"
                  }}
                >
                  {(addressEntryMode === "loading" || addressEntryMode === "ready") ? (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          fontSize: 12,
                          letterSpacing: 3,
                          fontWeight: 700,
                          color: "#0f766e"
                        }}
                      >
                        <span style={{ fontSize: 18, lineHeight: 1 }}>🎧</span>
                        <span>
                          {addressEntryMode === "ready"
                            ? (addressFlowText.loadingReadyLabel || "GUIDE READY")
                            : (addressFlowText.loadingBuildingLabel || "BUILDING YOUR GUIDE")}
                        </span>
                      </div>
                      <div
                        style={{
                          fontSize: addressEntryMode === "ready" ? 50 : 34,
                          fontWeight: 800,
                          letterSpacing: -1.1,
                          lineHeight: 1.06,
                          maxWidth: addressEntryMode === "loading" ? "9ch" : "none"
                        }}
                      >
                        {addressEntryMode === "ready"
                          ? (addressFlowText.loadingReadyTitle || "All set.")
                          : (addressFlowText.loadingInProgressTitle || "This usually takes a few seconds...")}
                      </div>
                      <div
                        style={{
                          fontSize: addressEntryMode === "ready" ? 24 : 16,
                          fontWeight: addressEntryMode === "ready" ? 700 : 400,
                          lineHeight: 1.25,
                          color: addressEntryMode === "ready" ? "#334155" : "#64748b",
                          marginTop: addressEntryMode === "ready" ? 8 : 2
                        }}
                      >
                        {resolvedAddressLabel || searchText || uiText.placeholder}
                      </div>

                      <div style={{ marginTop: 8, display: "flex", flexDirection: "column", gap: 12 }}>
                        {addressProgressSteps.map((stepLabel, idx) => {
                          const isAudioStep = idx === addressProgressSteps.length - 1;
                          const done = isAudioStep
                            ? autoplayOutcome !== "pending"
                            : addressEntryMode === "ready" || searchLoadingStep > idx;
                          const active = addressEntryMode === "loading" && searchLoadingStep === idx;
                          return (
                            <div
                              key={stepLabel}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 14,
                                fontSize: 16,
                                fontWeight: 700
                              }}
                            >
                              <span
                                style={{
                                  width: 34,
                                  height: 34,
                                  borderRadius: "50%",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  background: done ? "#047857" : "transparent",
                                  border: done ? "none" : "2px solid #0f766e",
                                  color: done ? "#ffffff" : active ? "#0f766e" : "#94a3b8",
                                  fontSize: 22,
                                  flexShrink: 0
                                }}
                              >
                                {done ? "✓" : active ? "◌" : "○"}
                              </span>
                              <span style={{ color: done || active ? "#111827" : "#64748b", lineHeight: 1.2 }}>{stepLabel}</span>
                            </div>
                          );
                        })}
                      </div>
                      {autoplayOutcome === "blocked" && (
                        <div style={{ marginTop: 20, textAlign: "center" }}>
                          <div style={{ fontSize: 22, fontWeight: 800, color: "#111827", marginBottom: 14 }}>
                            {addressFlowText.autoplayReadyTitle || "Your evacuation guide is ready!"}
                          </div>
                          <button
                            type="button"
                            onClick={async () => {
                              const media = routesAudioRef.current;
                              if (!media) return;
                              try {
                                media.playbackRate = routePlaybackRate;
                                media.defaultPlaybackRate = routePlaybackRate;
                                await playWithDisclaimer();
                                setShowAddressEntryFlow(false);
                                setAddressEntryMode("form");
                              } catch (error) {
                                setAddressEntryError("Audio could not start. Please try again.");
                              }
                            }}
                            style={{ padding: "14px 34px", border: 0, borderRadius: 14, background: "#f97316", color: "#fff", fontSize: 20, fontWeight: 800, cursor: "pointer" }}
                          >
                            {uiText.play || "Play"}
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <img
                        src={WUICastLogo}
                        alt="WUI-Cast"
                        style={{
                          marginTop: isMobile ? 8 : 4,
                          width: isMobile ? 220 : 260,
                          height: "auto",
                          display: "block"
                        }}
                      />

                      <div style={{ marginTop: isMobile ? 10 : 8, color: "#64748b", fontSize: isMobile ? 17 : 19, lineHeight: 1.45 }}>
                        {addressFlowText.subtitle || "Get your evacuation audio plan"}
                      </div>

                      <div style={{ marginTop: isMobile ? 22 : 20 }}>
                        <div
                          style={{
                            border: isMobile ? "4px solid #0f766e" : "3px solid #0f766e",
                            borderRadius: isMobile ? 28 : 22,
                            background: "#f8fafc",
                            display: "flex",
                            alignItems: "center",
                            padding: isMobile ? "14px 16px" : "14px 18px",
                            gap: 12
                          }}
                        >
                          <span style={{ fontSize: isMobile ? 22 : 24, color: "#0f766e" }}>🔍</span>
                          <input
                            autoFocus
                            type="text"
                            value={searchText}
                            onChange={(e) => {
                              handleSearchTextInput(e.target.value);
                              setAddressEntryError("");
                            }}
                            placeholder={uiText.placeholder}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleLocationSearch();
                            }}
                            style={{
                              flex: 1,
                              border: "none",
                              outline: "none",
                              background: "transparent",
                              fontSize: isMobile ? 17 : 20,
                              fontWeight: 600,
                              color: "#0f172a"
                            }}
                          />
                          {!!resolvedAddressLabel && (
                            <span style={{ fontSize: isMobile ? 30 : 26, color: "#0f766e", lineHeight: 1 }}>✓</span>
                          )}
                        </div>

                        {addressSuggestions.length > 0 && (
                          <div
                            style={{
                              marginTop: 8,
                              background: "#e2e8f0",
                              borderRadius: isMobile ? 26 : 18,
                              overflow: "hidden",
                              border: "1px solid #cbd5e1"
                            }}
                          >
                            {addressSuggestions.map((suggestion, idx) => (
                              <button
                                key={suggestion.id}
                                onClick={() => handleSuggestionPick(suggestion)}
                                style={{
                                  width: "100%",
                                  textAlign: "left",
                                  padding: isMobile ? "14px 16px" : "12px 14px",
                                  border: "none",
                                  borderTop: idx ? "1px solid #cbd5e1" : "none",
                                  background: "transparent",
                                  cursor: "pointer"
                                }}
                              >
                                <div style={{ fontSize: isMobile ? 16 : 17, fontWeight: 700, color: "#0f172a" }}>{suggestion.title}</div>
                                {suggestion.subtitle && (
                                  <div style={{ marginTop: 2, fontSize: isMobile ? 13 : 15, color: "#64748b" }}>{suggestion.subtitle}</div>
                                )}
                              </button>
                            ))}
                          </div>
                        )}

                        {isFetchingSuggestions && (
                          <div style={{ marginTop: 8, fontSize: 14, color: "#64748b", fontWeight: 600 }}>
                            {addressFlowText.searchingAddresses || "Searching addresses..."}
                          </div>
                        )}
                      </div>

                      {resolvedAddressLabel && (
                        <div style={{ marginTop: 10, fontSize: isMobile ? 17 : 18, color: "#0f766e", fontWeight: 700 }}>
                          ✓ {(addressFlowText.addressFoundPrefix || "Address found")} - {resolvedAddressLabel}
                        </div>
                      )}

                      {addressEntryError && (
                        <div style={{ marginTop: 10, fontSize: 15, color: "#b91c1c", fontWeight: 600 }}>
                          {addressEntryError}
                        </div>
                      )}

                      <button
                        onClick={() => handleLocationSearch()}
                        disabled={!searchText.trim() || isSearchingLoc}
                        style={{
                          marginTop: 16,
                          width: "100%",
                          background: !searchText.trim() ? "#9ca3af" : "#047857",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: isMobile ? 24 : 18,
                          padding: isMobile ? "18px 14px" : "16px 14px",
                          fontSize: isMobile ? 16 : 18,
                          fontWeight: 800,
                          cursor: !searchText.trim() || isSearchingLoc ? "default" : "pointer",
                          opacity: !searchText.trim() || isSearchingLoc ? 0.75 : 1
                        }}
                      >
                        {uiText.findPlan}
                      </button>

                      <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: isMobile ? 12 : 10 }}>
                        <button
                          onClick={handleUseMyLocation}
                          disabled={isSearchingLoc}
                          style={{
                            background: "#dbe2ea",
                            color: "#1f2937",
                            border: "1px solid #c7d2de",
                            borderRadius: isMobile ? 22 : 16,
                            padding: isMobile ? "14px 10px" : "14px 10px",
                            fontSize: isMobile ? 16 : 17,
                            fontWeight: 700,
                            cursor: isSearchingLoc ? "default" : "pointer",
                            opacity: isSearchingLoc ? 0.65 : 1
                          }}
                        >
                          {addressFlowText.useMyLocation || "Use my location"}
                        </button>
                        <button
                          onClick={handleStartPickOnMap}
                          disabled={isSearchingLoc}
                          style={{
                            background: "#dbe2ea",
                            color: "#1f2937",
                            border: "1px solid #c7d2de",
                            borderRadius: isMobile ? 22 : 16,
                            padding: isMobile ? "14px 10px" : "14px 10px",
                            fontSize: isMobile ? 16 : 17,
                            fontWeight: 700,
                            cursor: isSearchingLoc ? "default" : "pointer",
                            opacity: isSearchingLoc ? 0.65 : 1
                          }}
                        >
                          {addressFlowText.pickOnMap || "Pick on map"}
                        </button>
                      </div>

                    </>
                  )}
                </div>
              </div>
            )}

            {/* NEXT STEPS MODAL */}
            {showNextSteps && (
              <NextStepsModal
                isMobile={isMobile}
                uiText={uiText}
                activeStepsTab={activeStepsTab}
                setActiveStepsTab={setActiveStepsTab}
                onClose={() => setShowNextSteps(false)}
                onReplay={handlePlayAgain}
                showEvacuationTimesTab={true}
                enableVoiceAssistant={false}
                nextStepsVoiceAssistant={{}}
                guidedNextSteps={guidedNextSteps}
                activeNextStep={activeNextStep}
                activeNextStepIndex={activeNextStepIndex}
                setActiveNextStepIndex={setActiveNextStepIndex}
                completedNextStepSet={completedNextStepSet}
                hiddenNextStepKeys={hiddenNextStepKeys}
                setOpenInstructionKey={setOpenInstructionKey}
                stopResourcePlayback={stopResourcePlayback}
                toggleGuidedStepDetails={toggleGuidedStepDetails}
                isPlayableSegment={isPlayableSegment}
                segmentDuration={segmentDuration}
                resourceProgress={resourceProgress}
                activeResourceKey={activeResourceKey}
                resourceIsPlaying={resourceIsPlaying}
                playResourceSegment={playResourceSegment}
                seekWithinResourceSegment={seekWithinResourceSegment}
                openResourceAndPlay={openResourceAndPlay}
                markNextStepComplete={markNextStepComplete}
                skipActiveGuidedStep={skipActiveGuidedStep}
                resourceUI={resourceUI}
                shareWithNeighbors={shareWithNeighbors}
                faqList={faqList}
                simulationPdfUrl=""
                routeTableRows={routeTableRows}
                routeTableLoading={routeTableLoading}
                routeTableError={routeTableError}
                nearestNodeId={nearestNodeIdRef.current}
                onPdfAnalytics={() => {}}
                onSendAssistantStepContext={() => {}}
              />
            )}

            {/* LEGACY NEXT STEPS MODAL */}
            {false && showNextSteps && (
              <div
                role="dialog"
                aria-modal="true"
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(0,0,0,0.45)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 50
                }}
                onClick={() => setShowNextSteps(false)}
              >
                <div
                  style={{
                    width: "min(920px, 96vw)",
                    maxHeight: "86vh",
                    background: "#1c1c1c",
                    color: "#e5e7eb",
                    borderRadius: 12,
                    boxShadow: "0 12px 28px rgba(0,0,0,.28)",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Header */}
                  <div
                    style={{
                      padding: "16px 18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom: "1px solid rgba(255,255,255,0.08)"
                    }}
                  >
                    <div>
                      <div style={{ fontSize: 22, fontWeight: 700 }}>{uiText.takeActionTitle}</div>
                      {!isMobile? 
                        <div style={{ fontSize: 13, opacity: 0.8, marginTop: 2 }}>
                          {uiText.takeActionSubtitle}
                        </div>: null
                        }
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <button
                        onClick={handlePlayAgain}
                        style={{
                          background: "#0b5fff",
                          color: "#fff",
                          border: "none",
                          padding: "8px 12px",
                          borderRadius: 8,
                          cursor: "pointer",
                          fontWeight: 700
                        }}
                        aria-label="Play the podcast again from the start"
                        title="Play it again"
                      >
                        {uiText.replay}
                      </button>

                      {/* existing Close button */}
                      <button
                        onClick={() => setShowNextSteps(false)}
                        style={{
                          background: "transparent",
                          color: "#e5e7eb",
                          border: "none",
                          fontSize: 22,
                          lineHeight: 1,
                          cursor: "pointer",
                          padding: 6,
                          borderRadius: 8
                        }}
                        aria-label="Close"
                        title="Close"
                      >
                        ×
                      </button>
                    </div>
                  </div>

                  {/* Tabs */}
                  <div
                    style={{
                      padding: 8,
                      borderBottom: "1px solid rgba(255,255,255,0.08)",
                      display: "flex",
                      gap: 8
                    }}
                  >
                    {[
                      { key: "next", label: uiText.nextSteps },
                      { key: "times", label: uiText.evacTimesTab }
                    ].map((t) => {
                      const active = activeStepsTab === t.key;
                      return (
                        <button
                          key={t.key}
                          onClick={() => setActiveStepsTab(t.key)}
                          style={{
                            appearance: "none",
                            border: "none",
                            cursor: "pointer",
                            padding: "8px 12px",
                            borderRadius: 8,
                            fontWeight: 600,
                            background: active ? "#111827" : "transparent",
                            color: active ? "#fff" : "#cbd5e1",
                            outline: "none"
                          }}
                        >
                          {t.label}
                        </button>
                      );
                    })}
                  </div>

                  {/* Scrollable content area */}
                  <div
                    style={{
                      overflowY: "auto",
                      padding: "16px",
                      display: "flex",
                      flexDirection: "column",
                      gap: 16
                    }}
                  >
                    {activeStepsTab === "next" && (
                      <>
                        {/* The two resource cards (unchanged content, just styled) */}
                        <div
                          style={{
                            display: "grid",
                            gap: 14
                          }}
                        >
                          {resourceSegments.map((seg) => {
                            const meta = resourceMeta[seg.key] || {};
                            const canPlay = isPlayableSegment(seg);
                            const durSec  = segmentDuration(seg);
                            const a = resourcesAudioRef.current;
                            const isPlaying = activeResourceKey === seg.key && resourceIsPlaying;
                            const isActive = isPlaying; // drives the Stop/Play button and color
                            const played   = durSec ? Math.max(0, Math.min(resourceProgress[seg.key] || 0, durSec)) : 0;
                            const isOpen   = openInstructionKey === seg.key;
                            
                            const defaultHowTo = [
                              "Default step.",
                            ];

                            return (
                              <StepCard
                                key={seg.key}
                                title={meta.title || "Step"}
                                subtitle={meta.subtitle || resourceUI.default_subtitle || ""}
                                howTo={meta.howTo || defaultHowTo}
                                canPlay={canPlay}
                                isActive={isActive}
                                playedSec={played}
                                durationSec={durSec}
                                isOpen={isOpen}
                                isMobile={isMobile}
                                labels={uiText.stepCard}
                                onTogglePlay={() => {
                                  if (!canPlay) return;
                                  const a = resourcesAudioRef.current;
                                  if (activeResourceKey === seg.key) {
                                    // Same step: toggle pause/resume without rewinding
                                    if (a?.paused) {
                                      playResourceSegment(seg, { resumeIfSame: true });
                                    } else {
                                      stopResourcePlayback();
                                    }
                                  } else {
                                    // Switching steps: start that segment from its beginning
                                    playResourceSegment(seg);
                                  }
                                }}
                                onOpenInstructions={() => {
                                  if (activeResourceKey && activeResourceKey !== seg.key) {
                                    stopResourcePlayback();
                                  }
                                  logPodcastAction({
                                    platform: isMobile ? 'mobile' : 'web',
                                    action: 'next_step_clicked_instructions',
                                    cta: seg.key,
                                    node: String(nearestNodeIdRef.current || ''),
                                    param_lang: selectedLanguage,
                                    chapter: String(String(nearestNodeIdRef.current || '') + "_"+ selectedLanguage),
                                    podcast: selectedSimulation?.name || ''
                                  });
                                  setOpenInstructionKey(seg.key);      // open this card
                                  if (canPlay) playResourceSegment(seg); // autoplay
                                }}
                                onOpenLink={() => {
                                  if (activeResourceKey && activeResourceKey !== seg.key) {
                                    stopResourcePlayback();
                                  }
                                  openResourceAndPlay(seg, meta.href)
                                }}
                                onHide={() => {
                                  // collapse and stop audio if this card is the active one
                                  if (isActive) stopResourcePlayback();
                                  setOpenInstructionKey(null);
                                }}
                                onSeekProgress={(relSeconds) => {
                                  // If the clicked bar belongs to a different step, switch to it; else, just seek
                                  if (activeResourceKey !== seg.key) {
                                    stopResourcePlayback();
                                  }
                                  seekWithinResourceSegment(seg, relSeconds, true);
                                }}
                                gradientFrom="rgba(54,142,242,0.28)"
                                gradientTo="rgba(239,186,40,0.26)"
                                borderColor="rgba(255,255,255,0.14)"
                              />
                            );
                          })}


                        {/* Extra: Share with neighbors (no audio) */}
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, rgba(54, 142, 242, 0.3), rgba(239, 186, 40, 0.25))",
                            border: "1px solid rgba(255,255,255,0.08)",
                            borderRadius: 12,
                            padding: "16px"
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                            <div style={{ fontSize: 18, fontWeight: 700 }}>{resourceUI.share}</div>
                            <div style={{ display: "flex", gap: 8 }}>
                            <button
                              onClick={shareWithNeighbors}
                              style={{
                                background: "#f97316",
                                color: "#111827",
                                border: "none",
                                padding: "8px 12px",
                                borderRadius: 8,
                                cursor: "pointer",
                                fontWeight: 700
                              }}
                            >
                              {uiText.share_button}
                            </button>
                            </div>
                          </div>
                          {!isMobile? 
                            <div style={{ fontSize: 14, opacity: 0.8, marginTop: 6 }}>
                              {resourceUI.share_desc}
                            </div>
                            :
                            null
                          }
                        </div>


                        </div>

                        <section
                          aria-labelledby="disclaimer-title"
                          style={{
                            marginTop: 6,
                            paddingTop: 10,
                            borderTop: "1px solid rgba(255,255,255,0.08)",
                            textAlign: "left" // ensure not centered by any parent styles
                          }}
                        >
                          <h3
                            id="disclaimer-title"
                            style={{ fontSize: 20, fontWeight: 800, margin: "0 0 10px 0" }}
                          >
                            {uiText.disclaimerTitle}
                          </h3>

                          <ul
                            role="list"
                            style={{
                              listStyleType: "disc",
                              listStylePosition: "outside",
                              margin: 0,
                              paddingLeft: "1.25rem",
                              color: "#e5e7eb",
                              lineHeight: 1.6
                            }}
                          >
                            {(uiText.disclaimerBullets || []).map((b, i) => (
                              <li key={i}>{b}</li>
                            ))}
                          </ul>
                        </section>

                        {/* FAQ */}
                        <div
                          style={{
                            marginTop: 6,
                            paddingTop: 10,
                            borderTop: "1px solid rgba(255,255,255,0.08)"
                          }}
                        >
                          <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 10 }}>
                            FAQs
                          </div>
                          
                          {(faqList || []).map((qa) => (
                            <details
                              key={qa.key || qa.q}
                              style={{
                                background: "rgba(255,255,255,0.04)",
                                borderRadius: 10,
                                padding: "12px 14px",
                                marginBottom: 12,
                                border: "1px solid rgba(255,255,255,0.08)"
                              }}
                            >
                              <summary
                                style={{
                                  fontWeight: 700,
                                  cursor: "pointer",
                                  outline: "none",
                                  color: "#e5e7eb",
                                  marginBottom: '5px'
                                }}
                              >
                                {qa.q}
                              </summary>
                              <div
                                style={{
                                  marginTop: 8,
                                  color: "#f1f5f9",
                                  lineHeight: 1.5,
                                  opacity: 0.95,
                                  whiteSpace: "pre-line"
                                }}
                              >
                                {qa.a}
                              </div>
                            </details>
                          ))}

                          <div style={{ fontSize: 14, opacity: 0.9, marginBottom: 10 }}>
                            Please provide any questions or feedback{" "}
                            <a
                              href="https://forms.gle/ioy1MU1gxHcDDLSA8"     // <- put your real URL
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: "#93c5fd", textDecoration: "underline" }}
                            >
                              here
                            </a>.
                          </div>
                        </div>
                      </>
                    )}

                    {activeStepsTab === "times" && (
                      <div                        
                      >
                        {/* Placeholder for now */}
                        <EvacuationTimesTable
                          rows={routeTableRows}
                          loading={routeTableLoading}
                          error={routeTableError}
                          nodeId={nearestNodeIdRef.current}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            </div>
    </div>
  );
};

export default InteractiveMap;
